<template>
  <div>
    <el-card shadow="hover" :body-style="embedded ? { padding: '0' } : {}" :class="{ 'so-embedded': embedded }">
      <template v-if="!embedded" slot="header">
        <div class="clearfix">
          <span>销售订单</span>
          <div style="float: right">
            <el-button type="success" size="small" @click="exportCsv">导出CSV</el-button>
            <el-button v-if="$hasPerm('func:order:create')" type="primary" size="small" @click="openDialog()">新建销售订单</el-button>
          </div>
        </div>
      </template>

      <!-- 筛选（嵌入模式下客户已锁定，仍可按产品/状态搜索） -->
      <el-form :inline="true" :model="searchForm" class="mb-4">
        <el-form-item v-if="!embedded" label="客户姓名">
          <el-input v-model="searchForm.customerName" placeholder="请输入" style="width: 160px" @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="产品名称">
          <el-input v-model="searchForm.productName" placeholder="请输入" style="width: 160px" @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="searchForm.category" placeholder="全部" clearable style="width: 130px" @change="handleSearch">
            <el-option label="送存货" value="送存货"></el-option>
            <el-option label="尊贵卡A" value="尊贵卡A"></el-option>
            <el-option label="尊贵卡B" value="尊贵卡B"></el-option>
            <el-option label="尊贵卡C" value="尊贵卡C"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="存货类型">
          <el-select v-model="searchForm.stockType" placeholder="全部" clearable style="width: 130px" @change="handleSearch">
            <el-option label="普通存货" value="普通存货"></el-option>
            <el-option label="品鉴存货" value="品鉴存货"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="休眠状态">
          <el-select v-model="searchForm.dormantStatus" placeholder="全部" clearable style="width: 110px" @change="handleSearch">
            <el-option label="激活" :value="0"></el-option>
            <el-option label="缓冲期" :value="1"></el-option>
            <el-option label="休眠" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="销售日期">
          <el-date-picker v-model="searchForm.saleDateRange" type="daterange" unlink-panels range-separator="~"
                          start-placeholder="开始日期" end-placeholder="结束日期"
                          value-format="yyyy-MM-dd" style="width: 240px"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
        <el-form-item v-if="embedded" class="embed-actions">
          <el-button type="success" size="small" @click="exportCsv">导出CSV</el-button>
          <el-button v-if="$hasPerm('func:order:create')" type="primary" size="small" @click="openDialog()">新建销售订单</el-button>
        </el-form-item>
      </el-form>

      <!-- 列表：订单维度，每条订单一行；点击展开看明细 -->
      <el-table :data="orderList" stripe size="small" border row-key="id" :expand-row-keys="expandedRowKeys"
        @row-dblclick="row => openDialog(row)"
        @expand-change="onExpandChange">
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="detail-panel">
              <!-- 订单详情：订单级概况 -->
              <div class="detail-panel-title">
                <i class="el-icon-info"></i>
                <span>订单详情</span>
              </div>
              <div class="detail-card-row dbl-edit" @dblclick="openDialog(props.row)" title="双击任意位置修改订单">
                <div class="detail-card-body cols-4">
                  <div class="dc-cell"><span class="dc-label">订单ID</span><span class="dc-value">{{ props.row.id }}</span></div>
                  <div class="dc-cell"><span class="dc-label">订单编号</span><span class="dc-value">{{ props.row.orderNo || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">类型</span>
                    <el-tag v-if="props.row.category" :type="categoryTag(props.row.category)" :class="categoryClass(props.row.category)" size="mini">{{ vipCardLabel(props.row.category, props.row.cardSeq) }}</el-tag>
                    <span v-if="props.row.category === '送存货' && props.row.stockType" style="margin-left:4px;font-size:12px;color:#606266;">
                      - {{ props.row.stockType }}
                      <el-tag v-if="(props.row.stockType === '品鉴存货' || props.row.stockType === '试用存货') && props.row.applicableTypeName" size="mini" type="warning" style="margin-left:4px;">
                        {{ props.row.applicableTypeName }}
                      </el-tag>
                    </span>
                    <span v-else-if="!props.row.category" class="dc-value">-</span>
                  </div>
                  <div class="dc-cell"><span class="dc-label">销售日期</span><span class="dc-value">{{ formatDate(props.row.saleDate || props.row.createTime) || '-' }}</span></div>
                  <div v-if="props.row.category === '尊贵卡B'" class="dc-cell"><span class="dc-label">额度（协议剩余）</span><span class="dc-value">{{ props.row.totalAmount != null && props.row.totalAmount !== '' ? '¥' + Number(props.row.totalAmount) : '-' }}</span></div>
                  <div v-if="props.row.category === '尊贵卡B'" class="dc-cell"><span class="dc-label">新出库已提额度</span><span class="dc-value">¥{{ props.row.newoutTakenAmount != null && props.row.newoutTakenAmount !== '' ? Number(props.row.newoutTakenAmount) : 0 }}</span></div>
                  <div v-if="props.row.category === '尊贵卡B'" class="dc-cell"><span class="dc-label">新出库提货日期</span><span class="dc-value">{{ props.row.newoutPickupDate ? String(props.row.newoutPickupDate).slice(0,10) : '-' }}</span></div>
                  <div v-if="props.row.category === '尊贵卡B'" class="dc-cell highlight"><span class="dc-label">剩余额度</span><span class="dc-value highlight-value">{{ props.row.vipBRemaining != null ? '¥' + props.row.vipBRemaining : (props.row.quotaLimit != null && props.row.quotaLimit !== '' ? '¥' + props.row.quotaLimit : '-') }}</span></div>
                  <div v-if="props.row.category === '尊贵卡B'" class="dc-cell"><span class="dc-label">应该剩余额度</span><span class="dc-value">{{ props.row.shouldQuotaRemaining != null ? '¥' + props.row.shouldQuotaRemaining : (props.row.vipBRemaining != null ? '¥' + props.row.vipBRemaining : '-') }}</span></div>
                  <div v-if="props.row.category === '尊贵卡B'" class="dc-cell highlight"><span class="dc-label">实际剩余额度</span><span class="dc-value highlight-value">{{ props.row.actualQuotaRemaining != null ? '¥' + props.row.actualQuotaRemaining : '¥0' }}</span></div>
                  <div v-if="props.row.category === '尊贵卡B'" class="dc-cell"><span class="dc-label">实际剩余时间</span><span class="dc-value">{{ formatDateMinute(props.row.actualUpdateTime) || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">明细总金额</span><span class="dc-value">¥{{ rowTotal(props.row) }}</span></div>
                  <div class="dc-cell"><span class="dc-label">欠款</span>
                    <span class="dc-value" :class="{ warn: Number(props.row.debt || 0) > 0 }">{{ props.row.category === '尊贵卡A' && !(Number(props.row.debt) > 0) ? '—' : ('¥' + Number(props.row.debt || 0).toFixed(2)) }}</span>
                  </div>
                  <template v-if="['尊贵卡B','尊贵卡C'].includes(props.row.category)">
                    <div class="dc-cell"><span class="dc-label">合同服务起始日</span><span class="dc-value">{{ String(props.row.serviceFeeStartDate || '').slice(0, 10) || '-' }}</span></div>
                    <div class="dc-cell"><span class="dc-label">免服务费期限</span><span class="dc-value">{{ props.row.freeServiceMonths != null ? (props.row.freeServiceMonths + ' 个月') : '-' }}</span></div>
                    <div class="dc-cell"><span class="dc-label">服务费起始日</span><span class="dc-value">{{ computeServiceFeeStart(props.row.serviceFeeStartDate, props.row.freeServiceMonths) || '-' }}</span></div>
                    <!-- <div class="dc-cell"><span class="dc-label">免服务费剩余天数</span><span class="dc-value">{{ computeFreeServiceDaysLeft(props.row) }}</span></div> -->

                    <div class="dc-cell"><span class="dc-label">服务费到期时间</span><span class="dc-value">{{ computeServiceFeeDue(props.row) || '-' }}</span></div>
                    <div class="dc-cell"><span class="dc-label">服务费到期提醒</span><span class="dc-value">{{ serviceRemindDate(props.row) || '-' }}</span></div>
                    <div class="dc-cell"><span class="dc-label">休眠状态</span>
                      <el-tag :type="dormantTagType(props.row.dormantStatusText)" size="mini">
                        {{ props.row.dormantStatusText || '激活' }}
                      </el-tag>
                    </div>
                  </template>
                  <div class="dc-cell w4"><span class="dc-label">附件</span>
                    <template v-if="signList(props.row).length">
                      <span class="file-thumbs">
                        <template v-for="(u, i) in signList(props.row)">
                          <el-image v-if="isImageUrl(u)" :key="'sf'+i" :src="fullUrl(u)"
                                    :preview-src-list="signList(props.row).filter(x => isImageUrl(x)).map(x => fullUrl(x))"
                                    fit="cover" class="file-thumb-sm"></el-image>
                          <a v-else :key="'sfa'+i" :href="fullUrl(u)" target="_blank" rel="noopener" class="file-link-sm">{{ fileShort(u) }}</a>
                        </template>
                      </span>
                    </template>
                    <span v-else class="muted">未上传</span>
                  </div>
                  <div class="dc-cell w4"><span class="dc-label">备注</span><span class="dc-value">{{ props.row.remark || '-' }}</span></div>
                </div>
              </div>

              <!-- 订单明细：尊贵卡B 仅作展示（无 已领取/在途/剩余可领取 等业务字段） -->
              <div class="detail-panel-title" style="margin-top: 14px;">
                <i class="el-icon-document"></i>
                <span>订单明细 · 共 {{ (props.row.details || []).length }} 项</span>
                <span v-if="props.row.category === '送存货'" style="margin-left:12px;">
                  <el-tag size="mini" type="warning" style="font-weight:600;">存货类型: {{ props.row.stockType || '普通存货' }}</el-tag>
                  <el-tag v-if="(props.row.stockType === '品鉴存货' || props.row.stockType === '试用存货') && props.row.applicableTypeName" size="mini" type="success" style="margin-left:6px;font-weight:600;">试用类型: {{ props.row.applicableTypeName }}</el-tag>
                </span>
                <span v-if="props.row.category === '尊贵卡B'" style="margin-left:8px;color:#f56c6c;font-size:12px;font-weight:normal;">（尊贵卡B 仅作展示，不计入剩余金额/已提货等规则）</span>
              </div>
              <div v-if="!(props.row.details || []).length" class="detail-empty">该订单暂无明细</div>
              <div v-else class="detail-grid dbl-edit" @dblclick="openDialog(props.row)" title="双击任意位置修改订单">
                <div v-for="(d, i) in props.row.details" :key="i" class="detail-card-row" :class="{ 'detail-card-row--voided': ['尊贵卡A','尊贵卡C'].includes(props.row.category) && Number(d.voided) === 1 }">
                  <div class="detail-card-head">
                    <span class="dc-no">#{{ i + 1 }}</span>
                    <span class="dc-name">{{ d.productName ? vipName(d.productName, props.row.category) : '—' }}</span>
                    <span v-if="['尊贵卡A','尊贵卡C'].includes(props.row.category) && Number(d.voided) === 1" class="row-void-stamp">已作废</span>
                    <span class="dc-spec" v-if="d.spec">规格：{{ d.spec }}</span>
                  </div>
                  <div class="detail-card-body" :class="{ 'send-stock-cells': props.row.category === '送存货' }">
                    <div class="dc-cell"><span class="dc-label">单价</span><span class="dc-value">¥{{ d.price || 0 }}</span></div>
                    <div class="dc-cell"><span class="dc-label">数量</span><span class="dc-value">{{ d.quantity || 0 }} 件</span></div>
                    <div v-if="!['尊贵卡A','尊贵卡B','尊贵卡C'].includes(props.row.category)" class="dc-cell"><span class="dc-label">赠送数量</span><span class="dc-value">{{ d.giftQuantity || 0 }} 件</span></div>
                    <div class="dc-cell"><span class="dc-label">补贴</span><span class="dc-value">¥{{ d.subsidyAmount || 0 }}</span></div>
                    <div class="dc-cell"><span class="dc-label">实付</span><span class="dc-value strong">¥{{ d.actualAmount || 0 }}</span></div>
                    <!-- 送存货/尊贵卡A·C：新出库已提数量 + 提货日期（按产品）；尊贵卡B 的已提额度在卡级显示 -->
                    <div v-if="['送存货','尊贵卡A','尊贵卡C'].includes(props.row.category)" class="dc-cell"><span class="dc-label">新出库已提数量</span><span class="dc-value">{{ d.newoutTakenQuantity || 0 }} 件</span></div>
                    <div v-if="['送存货','尊贵卡A','尊贵卡C'].includes(props.row.category)" class="dc-cell"><span class="dc-label">新出库提货日期</span><span class="dc-value">{{ d.pickupDate ? String(d.pickupDate).slice(0,10) : '-' }}</span></div>
                    <!-- 销售订单明细已去掉欠款字段 -->

                    <div v-if="!['尊贵卡A','尊贵卡B','尊贵卡C'].includes(props.row.category)" class="dc-cell"><span class="dc-label">存货数量</span><span class="dc-value">{{ d.stockQuantity != null ? d.stockQuantity : ((Number(d.quantity) || 0) + (Number(d.giftQuantity) || 0)) }} 件</span></div>
                    <div v-if="props.row.category === '送存货'" class="dc-cell"><span class="dc-label">已提数量（含新出库）</span><span class="dc-value">{{ (Number(d.takenQuantity) || 0) + (Number(d.newoutTakenQuantity) || 0) }} 件</span></div>
                    <div v-if="props.row.category === '送存货'" class="dc-cell highlight"><span class="dc-label">剩余存货</span><span class="dc-value highlight-value">{{ d.remainingStock != null ? d.remainingStock : ((Number(d.quantity) || 0) + (Number(d.giftQuantity) || 0)) }} 件</span></div>

                    <div v-if="['尊贵卡A','尊贵卡C'].includes(props.row.category)" class="dc-cell-group">
                      <div class="dc-cell"><span class="dc-label">领取上限</span><span class="dc-value">{{ d.stockLimit || 0 }} 件</span></div>
                      <div class="dc-cell"><span class="dc-label">已领取数量（含新出库）</span><span class="dc-value">{{ Math.max(0, (Number(d.stockLimit) || 0) - (d.remainingPickup != null ? Number(d.remainingPickup) : (Number(d.quantity) || 0))) }} 件</span></div>
                      <div class="dc-cell highlight"><span class="dc-label">剩余可领取数量</span><span class="dc-value highlight-value">{{ d.remainingPickup != null ? d.remainingPickup : (d.quantity || 0) }} 件</span></div>
                    </div>
                    <div class="dc-cell w4"><span class="dc-label">备注</span><span class="dc-value">{{ d.remark || '-' }}</span></div>

                    <!-- 尊贵卡C 专属：第一行 协议剩余 + 应该剩余；第二行 实际剩余 + 实际剩余时间 -->
                    <div v-if="props.row.category === '尊贵卡C'" style="margin-top:8px;">
                      <div class="dc-last-row-triple" style="margin-bottom:6px;">
                        <div class="dc-cell"><span class="dc-label">协议剩余</span><span class="dc-value">{{ d.agreementRemaining != null ? d.agreementRemaining : (d.quantity || 0) }} 件</span></div>
                        <div class="dc-cell highlight"><span class="dc-label">应该剩余</span><span class="dc-value highlight-value">{{ d.shouldRemaining != null ? d.shouldRemaining : (d.remainingPickup != null ? d.remainingPickup : (d.stockLimit || d.quantity || 0)) }} 件</span></div>
                      </div>
                      <div class="dc-last-row-triple">
                        <div class="dc-cell highlight"><span class="dc-label">实际剩余</span><span class="dc-value highlight-value">{{ d.actualRemaining != null ? d.actualRemaining : 0 }} 件</span></div>
                        <div class="dc-cell"><span class="dc-label">实际剩余时间</span><span class="dc-value">{{ formatDateMinute(d.actualUpdateTime || props.row.actualUpdateTime) || '-' }}</span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 还款计划 -->
              <div v-if="props.row.category !== '尊贵卡A' && Number(props.row.debt || 0) > 0" style="margin-top:14px">
                <div class="detail-panel-title">
                  <i class="el-icon-wallet"></i>
                  <span>还款计划</span>
                  <span style="margin-left:8px;color:#E6A23C;font-size:12px;font-weight:normal;">
                    （信用卡分期模式）还款规则：按期数顺序自动分配，优先补齐早期欠款。约定日期前有还款=按时（不占配额），超期未还=逾期（永久占用配额）。
                  </span>
                </div>
                <div v-if="(paymentPlansMap[props.row.id] || []).length" class="detail-card-row" style="padding:12px">
                  <el-table :data="paymentPlansMap[props.row.id]" border size="small" style="width:100%"
                    :header-cell-style="{background:'#f5f7fa', color:'#606266'}">
                    <el-table-column label="期数" width="80" align="center">
                      <template slot-scope="scope">
                        <el-tag size="mini" type="warning">第{{scope.row.period}}期</el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column label="约定日期" align="center" min-width="120">
                      <template slot-scope="scope">{{ scope.row.expectedDate || '-' }}</template>
                    </el-table-column>
                    <el-table-column label="约定金额" width="100" align="center">
                      <template slot-scope="scope">
                        <span style="font-weight:600">¥{{ Number(scope.row.expectedAmount || 0).toFixed(2) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="已还金额" width="100" align="center">
                      <template slot-scope="scope">
                        <span :style="{color: Number(scope.row.paidAmount || 0) > 0 ? '#67C23A' : '#909399', fontWeight: 600}">¥{{ Number(scope.row.paidAmount || 0).toFixed(2) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="剩余欠款" width="100" align="center">
                      <template slot-scope="scope">
                        <span :style="{color: (Number(scope.row.expectedAmount || 0) - Number(scope.row.paidAmount || 0)) > 0 ? '#F56C6C' : '#67C23A', fontWeight: 600}">
                          ¥{{ (Number(scope.row.expectedAmount || 0) - Number(scope.row.paidAmount || 0)).toFixed(2) }}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column label="首次还款日期" align="center" min-width="120">
                      <template slot-scope="scope">{{ scope.row.firstPaymentDate || '-' }}</template>
                    </el-table-column>
                    <el-table-column label="状态" width="90" align="center">
                      <template slot-scope="scope">
                        <el-tag v-if="scope.row.status === 1 || (scope.row.paidAmount >= scope.row.expectedAmount)" type="success" size="mini">已还</el-tag>
                        <el-tag v-else-if="Number(scope.row.paidAmount || 0) > 0" type="warning" size="mini">未还清</el-tag>
                        <el-tag v-else type="info" size="mini">待还</el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column label="逾期标记" width="100" align="center">
                      <template slot-scope="scope">
                        <el-tag v-if="isOverdue(scope.row)" type="danger" size="mini" effect="dark">
                          <i class="el-icon-warning"></i> 逾期
                        </el-tag>
                        <el-tag v-else-if="isBeforeExpected(scope.row)" type="info" size="mini">未到期</el-tag>
                        <el-tag v-else type="success" size="mini">未逾期</el-tag>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div v-else class="detail-empty" style="padding:12px">该订单暂无还款计划</div>
              </div>

              <!-- 欠款变更记录 -->
              <div style="margin-top:14px">
                <div class="detail-panel-title">
                  <i class="el-icon-time"></i>
                  <span>欠款变更记录</span>
                  <span style="margin-left:8px;color:#909399;font-size:12px;font-weight:normal;">
                    <i class="el-icon-info"></i> 以下变更记录按操作先后排序，最新操作在最上；顶部为真实操作时间，<span class="biz-time">蓝色</span>为手填的回款 / 修改·变更时间
                  </span>
                </div>
                <div class="detail-card-row change-log-row" style="padding:12px 8px">
                  <el-timeline v-if="(changeLogsMap[props.row.id] || []).length">
                    <el-timeline-item v-for="log in changeLogsMap[props.row.id]" :key="log.id"
                                      :timestamp="formatDate(log.createTime)" placement="top" size="normal" type="warning">
                      <div style="font-size:13px">
                        <el-tag size="mini" type="warning">{{ log.action }}</el-tag>
                        <span style="margin-left:8px">¥{{ log.oldValue || '0' }} → <b style="color:#f56c6c">¥{{ (log._debt && log._debt.amount) || '0' }}</b></span>
                        <span v-if="log.operator" style="margin-left:10px;color:#303133;font-weight:600">操作人:{{ log.operator }}</span>
                        <!-- 业务时间：有回款只显示回款，否则显示修改/变更时间，两者不同时显示；统一蓝色 -->
                        <span v-if="log._debt && log._debt.paymentTime" class="biz-time" style="margin-left:10px">回款时间:{{ log._debt.paymentTime }}<template v-if="log._debt.paymentAmount"> · 回款金额:¥{{ log._debt.paymentAmount }}</template></span>
                        <span v-else-if="log.modifyTime" class="biz-time" style="margin-left:10px">修改/变更时间:{{ formatDate(log.modifyTime) }}</span>
                      </div>
                    </el-timeline-item>
                  </el-timeline>
                  <div v-else class="muted">暂无欠款变更记录</div>
                </div>
              </div>

              <!-- 明细 / 额度 变更记录（尊贵卡B 显示"额度变更记录"——修改额度会有记录） -->
              <div style="margin-top:14px">
                <div class="detail-panel-title"><i class="el-icon-tickets"></i><span>{{ props.row.category === '尊贵卡B' ? '额度变更记录' : '明细变更记录' }}</span></div>
                <div class="detail-card-row change-log-row" style="padding:12px 8px">
                  <el-timeline v-if="(detailLogsMap[props.row.id] || []).length">
                    <el-timeline-item v-for="log in detailLogsMap[props.row.id]" :key="log.id"
                                      :timestamp="formatDate(log.createTime)" placement="top" size="normal" type="success">
                      <div style="font-size:13px">
                        <el-tag size="mini" type="success">{{ log.action }}</el-tag>
                        <span v-if="log.operator" style="margin-left:10px;color:#303133;font-weight:600">操作人:{{ log.operator }}</span>
                        <span v-if="log.modifyTime" class="biz-time" style="margin-left:10px">修改/变更时间:{{ formatDate(log.modifyTime) }}</span>
                        <!-- 额度修改（兼容旧"剩余金额修改"记录）：简单数值对比 -->
                        <div v-if="log.action === '额度修改' || log.action === '剩余金额修改'" style="margin-top:8px;font-size:13px">
                          <span>¥{{ log.oldValue || '0' }}</span>
                          <span style="margin:0 8px;color:#909399">→</span>
                          <b style="color:#E6A23C">¥{{ log.newValue || '0' }}</b>
                        </div>
                        <!-- 明细修改：左右卡片 diff -->
                        <div v-else class="detail-diff-wrap">
                          <div class="detail-diff-section">
                            <div class="detail-diff-label old">变更前</div>
                            <div class="detail-diff-cards">
                              <div v-for="(b, i) in (log._oldBlocks || [])" :key="'o'+i" class="detail-diff-card old-card" :class="{ 'card-deleted': b.deleted, 'card-voided': b.voided }">
                                <div class="ddc-title">{{ b.title }}</div>
                                <div class="ddc-fields">
                                  <span v-for="(f, j) in b.fields" :key="j" class="ddc-field" :class="{ 'old-changed': f.changed && !b.deleted }"><span class="ddc-k">{{ f.k }}</span><span class="ddc-v">{{ f.v }}</span></span>
                                </div>
                              </div>
                              <div v-if="!(log._oldBlocks || []).length" class="muted">(空)</div>
                            </div>
                          </div>
                          <div class="detail-diff-section">
                            <div class="detail-diff-label new">变更后</div>
                            <div class="detail-diff-cards">
                              <div v-for="(b, i) in (log._newBlocks || [])" :key="'n'+i" class="detail-diff-card new-card" :class="{ 'card-added': b.isNew, 'card-changed': b.isChanged, 'card-voided': b.voided }">
                                <div class="ddc-title">{{ b.title }}</div>
                                <div class="ddc-fields">
                                  <span v-for="(f, j) in b.fields" :key="j" class="ddc-field" :class="{ changed: f.changed }"><span class="ddc-k">{{ f.k }}</span><span class="ddc-v">{{ f.v }}</span></span>
                                </div>
                              </div>
                              <div v-if="!(log._newBlocks || []).length" class="muted">(空)</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-timeline-item>
                  </el-timeline>
                  <div v-else class="muted">{{ props.row.category === '尊贵卡B' ? '暂无额度变更记录' : '暂无明细变更记录' }}</div>
                </div>
              </div>

              <!-- 附件变更记录 -->
              <div style="margin-top:14px">
                <div class="detail-panel-title"><i class="el-icon-paperclip"></i><span>附件变更记录</span></div>
                <div class="detail-card-row change-log-row" style="padding:12px 8px">
                  <el-timeline v-if="(attachLogsMap[props.row.id] || []).length">
                    <el-timeline-item v-for="log in attachLogsMap[props.row.id]" :key="log.id"
                                      :timestamp="formatDate(log.createTime)" placement="top" size="normal" type="primary">
                      <div style="font-size:13px">
                        <el-tag size="mini" :type="log.action === '新增' ? 'success' : (log.action === '删除' ? 'danger' : 'primary')">{{ log.action }}</el-tag>
                        <span v-if="log.operator" style="margin-left:10px;color:#303133;font-weight:600">操作人:{{ log.operator }}</span>
                        <span v-if="log.modifyTime" class="biz-time" style="margin-left:10px">修改/变更时间:{{ formatDate(log.modifyTime) }}</span>
                        <div style="margin-top:8px">
                          <div v-if="log.oldValue">
                            <div class="muted small">原值:</div>
                            <div class="attach-log-imgs">
                              <template v-for="(u, i) in splitUrls(log.oldValue)">
                                <el-image v-if="isImage(u)" :key="'o'+log.id+i"
                                          :src="full(u)" :preview-src-list="splitUrls(log.oldValue).filter(isImage).map(full)"
                                          fit="cover" class="attach-log-thumb"></el-image>
                                <a v-else :key="'oa'+log.id+i" :href="full(u)" target="_blank" class="link" style="margin-right:8px">{{ fileShort(u) }}</a>
                              </template>
                            </div>
                          </div>
                          <div v-if="log.newValue" style="margin-top:6px">
                            <div class="muted small">新值:</div>
                            <div class="attach-log-imgs">
                              <template v-for="(u, i) in splitUrls(log.newValue)">
                                <el-image v-if="isImage(u)" :key="'n'+log.id+i"
                                          :src="full(u)" :preview-src-list="splitUrls(log.newValue).filter(isImage).map(full)"
                                          fit="cover" class="attach-log-thumb"></el-image>
                                <a v-else :key="'na'+log.id+i" :href="full(u)" target="_blank" class="link" style="margin-right:8px">{{ fileShort(u) }}</a>
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-timeline-item>
                  </el-timeline>
                  <div v-else class="muted">暂无附件变更记录</div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod"></el-table-column>
        <el-table-column v-if="!embedded" prop="orderNo" label="订单编号" min-width="180"></el-table-column>
        <el-table-column v-if="embedded" label="销售日期" width="120" align="center">
          <template slot-scope="s">{{ formatDate(s.row.saleDate || s.row.createTime) || '-' }}</template>
        </el-table-column>
        <el-table-column v-if="!embedded" prop="customerName" label="客户姓名" min-width="100"></el-table-column>
        <el-table-column label="类型" min-width="120" align="center">
          <template slot-scope="s">
            <template v-if="s.row.category === '送存货'">
              <el-tag v-if="s.row.stockType === '品鉴存货' || s.row.stockType === '试用存货'" type="warning" size="small">
                品鉴存货<span v-if="s.row.applicableTypeName">·{{ s.row.applicableTypeName }}</span>
              </el-tag>
              <el-tag v-else :type="categoryTag(s.row.category)" :class="categoryClass(s.row.category)" size="small">
                {{ s.row.stockType || '普通存货' }}
              </el-tag>
            </template>
            <el-tag v-else-if="s.row.category" :type="categoryTag(s.row.category)" :class="categoryClass(s.row.category)" size="small">{{ vipCardLabel(s.row.category, s.row.cardSeq) }}</el-tag>
            <span v-else class="muted">-</span>
          </template>
        </el-table-column>
        <el-table-column label="产品名称" min-width="160" show-overflow-tooltip>
          <template slot-scope="s">{{ orderProductNames(s.row) }}</template>
        </el-table-column>
        <el-table-column v-if="embedded" label="数量" width="80" align="right">
          <template slot-scope="s">{{ rowQty(s.row) }}</template>
        </el-table-column>
        <el-table-column label="明细总金额" width="120" align="right">
          <template slot-scope="s">
            <span style="color:#409eff;font-weight:600">¥{{ rowTotal(s.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="欠款" width="120" align="right">
          <template slot-scope="s">
            <!-- 尊贵卡A：欠款不可填写，纯展示；0/空 显示横杠 -->
            <span v-if="s.row.category === '尊贵卡A'"
                  :class="{ warn: Number(s.row.debt || 0) > 0 }">{{ Number(s.row.debt || 0) > 0 ? '¥' + Number(s.row.debt).toFixed(2) : '—' }}</span>
            <!-- 有权限且有欠款：可点击登记回款 -->
            <span v-else-if="$hasPerm('func:order:repayment') && Number(s.row.debt || 0) > 0" :class="{ warn: Number(s.row.debt || 0) > 0 }"
                  style="cursor:pointer;text-decoration:underline"
                  title="点击登记回款"
                  @click="editDebtInline(s.row)">¥{{ Number(s.row.debt || 0).toFixed(2) }} <i class="el-icon-edit"></i></span>
            <!-- 其他：纯文本显示 -->
            <span v-else :class="{ warn: Number(s.row.debt || 0) > 0 }">¥{{ Number(s.row.debt || 0).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="免服务费期限" width="120" align="center">
          <template slot-scope="s">
            <span v-if="s.row.category === '送存货'" class="muted">-</span>
            <span v-else-if="s.row.category === '尊贵卡A'">终身</span>
            <span v-else-if="s.row.freeServiceMonths != null">{{ s.row.freeServiceMonths }} 个月</span>
            <span v-else class="muted">-</span>
          </template>
        </el-table-column>
        <el-table-column label="服务费起始日" width="130" align="center">
          <template slot-scope="s">
            <span v-if="s.row.category === '尊贵卡A'">终身</span>
            <template v-else>{{ computeServiceFeeStart(s.row.serviceFeeStartDate, s.row.freeServiceMonths) || '-' }}</template>
          </template>
        </el-table-column>
        <el-table-column label="服务费到期提醒" width="160" align="center">
          <template slot-scope="s">
            <span v-if="s.row.category === '尊贵卡A'">终身</span>
            <span v-else style="color:#f56c6c">{{ serviceRemindDate(s.row) || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="休眠状态" width="96" align="center">
          <template slot-scope="s">
            <span v-if="s.row.category === '送存货'" class="muted">-</span>
            <span v-else-if="s.row.category === '尊贵卡A'">终身</span>
            <el-tag v-else :type="dormantTagType(s.row.dormantStatusText)" size="small">
              {{ s.row.dormantStatusText || '激活' }}
            </el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column label="服务费期限" width="220" align="center">
          <template slot-scope="s">
            <span v-if="s.row.category === '尊贵卡A'">终身</span>
            <template v-else>{{ computeServiceTerm(s.row) || '-' }}</template>
          </template>
        </el-table-column> -->

        <!-- <el-table-column label="免服务费剩余天数" width="140" align="center">
          <template slot-scope="s">
            <span v-if="s.row.category === '尊贵卡A'">终身</span>
            <template v-else-if="s.row.freeServiceDays != null">{{ s.row.freeServiceDays }} 天</template>
            <span v-else class="muted">-</span>
          </template>
        </el-table-column> -->

        <el-table-column v-if="!embedded" prop="id" label="订单ID" width="80"></el-table-column>
        <el-table-column label="操作" :width="embedded ? 170 : 240" :fixed="embedded ? false : 'right'">
          <template slot-scope="s">
            <el-button v-if="$hasPerm('func:order:edit')" size="mini" type="primary" @click="openDialog(s.row)">修改</el-button>
            <el-button v-if="!embedded" size="mini" type="warning" @click="openAgrLog(s.row)">变更记录</el-button>
            <el-button v-if="$hasPerm('func:order:delete')" size="mini" type="danger" @click="handleDelete(s.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="mt-4">
        <el-pagination
          @size-change="s => { pageSize = s; loadList() }"
          @current-change="p => { currentPage = p; loadList() }"
          :current-page="currentPage" :page-sizes="[10, 20, 50]" :page-size="pageSize"
          :layout="embedded ? 'slot, total, sizes, prev, pager, next, jumper' : 'total, sizes, prev, pager, next, jumper'"
          :total="total">
          <span v-if="embedded" class="customer-totals">
            <span style="margin-right:50px;font-size:17px">总计金额：<b>¥{{ customerTotalAmount.toFixed(2) }}</b></span>
            <span style="margin-right:50px;font-size:17px">总计欠款：<b :class="{ 'customer-totals-warn': customerTotalDebt > 0 }">¥{{ customerTotalDebt.toFixed(2) }}</b></span>
          </span>
        </el-pagination>
      </div>
    </el-card>

    <!-- 新建/修改对话框 -->
    <el-dialog :title="form.id ? '编辑订单' : '新建订单'" :visible.sync="dialogVisible" width="900px" top="6vh" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
      <el-form :model="form" ref="form" label-width="130px" size="small">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="销售日期">
              <el-date-picker v-model="form.saleDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" popper-class="sales-order-date-popper" style="width: 100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="类型" required>
              <el-select v-model="form.category" placeholder="请选择类型" style="width: 100%" clearable @change="onCategoryChange">
                <el-option v-for="t in categoryOptions" :key="t" :label="t" :value="t"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 送存货：存货类型 与 试用类型 下拉框 -->
        <el-row v-if="form.category === '送存货'" :gutter="24">
          <el-col :span="12">
            <el-form-item label="存货类型" required>
              <el-select v-model="form.stockType" placeholder="请选择存货类型" style="width: 100%" clearable @change="onStockTypeChange">
                <el-option label="普通存货" value="普通存货"></el-option>
                <el-option label="品鉴存货" value="品鉴存货"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="form.stockType === '品鉴存货' || form.stockType === '试用存货'" :span="12">
            <el-form-item label="试用类型" required>
              <el-select v-model="form.applicableTypeId" placeholder="请选择试用类型" style="width: 100%" clearable @change="onApplicableTypeChange">
                <el-option v-for="at in applicableTypeOptions" :key="at.id" :label="at.name" :value="at.id">
                  <span style="display:flex;align-items:center;justify-content:space-between">
                    <span>{{ at.name }}</span>
                    <el-tag v-if="at.color" :color="at.color" size="mini" style="color:#fff;margin-left:8px;border:none;">{{ at.name }}</el-tag>
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 尊贵卡A / 尊贵卡B / 尊贵卡C 专属字段 -->
        <el-row v-if="['尊贵卡A','尊贵卡B','尊贵卡C'].includes(form.category)" :gutter="24">
          <el-col :span="12">
            <el-form-item label="合同服务起始日" required>
              <el-date-picker v-model="form.serviceFeeStartDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" popper-class="sales-order-date-popper" style="width: 100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col v-if="['尊贵卡B','尊贵卡C'].includes(form.category)" :span="12">
            <el-form-item label="免服务费期限">
              <el-input v-model.number="form.freeServiceMonths" type="number" min="0" max="600" placeholder="如 24" style="width: 100%">
                <template slot="append">月</template>
              </el-input>
              <span style="color:#909399;font-size:12px;display:block;line-height:1.4;">默认 24，期内不收服务费</span>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 当前服务年度：紧贴在合同服务起始日正下方，仅当填了合同服务起始日后才出现 -->
        <el-row v-if="['尊贵卡A', '尊贵卡B', '尊贵卡C'].includes(form.category) && form.serviceFeeStartDate" :gutter="24" style="margin-top:-6px;">
          <el-col :span="24">
            <el-form-item label="当前服务年度" style="margin-bottom:12px;">
              <span style="color:#409EFF;font-weight:600;font-size:14px;">{{ getServiceYearWindow() }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="['尊贵卡B','尊贵卡C'].includes(form.category)" :gutter="24">
          <el-col :span="12">
            <el-form-item label="服务费起始日">
              <el-input :value="derivedServiceFeeStart" disabled placeholder="= 合同起始日 + 免服务期(月)，系统派生"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="['尊贵卡B','尊贵卡C'].includes(form.category)" :gutter="24">
          <el-col :span="12">
            <el-form-item label="到期提示天数">
              <el-input v-model="form.expiryWarningDays" type="number" min="1" max="365" placeholder="默认 30" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- 休眠状态单选去掉：跟随服务费已缴勾选自动联动（见 syncDormantFromPaid） -->

        </el-row>
        <!-- 尊贵卡B 额度与实际剩余模块（置于服务费已缴纳正上方） -->
        <template v-if="form.category === '尊贵卡B'">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="额度（协议剩余）" required>
                <el-input-number v-model="form.totalAmount" :min="0" :precision="2" controls-position="right" style="width:100%" placeholder="基础额度"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="应该剩余额度">
                <div class="unit-wrap">
                  <el-input :value="computeShouldQuotaRemaining()" disabled placeholder="名义剩余额度"></el-input>
                  <span class="unit-suffix">元</span>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="实际剩余额度">
                <div class="unit-wrap">
                  <el-input-number v-model="form.actualQuotaRemaining" :min="0" :max="computeShouldQuotaRemaining()" :precision="2" controls-position="right" style="width:100%" placeholder="手填实际放行额度" @change="onActualQuotaRemainingChange"></el-input-number>
                  <span class="unit-suffix">元</span>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="实际剩余时间">
                <el-date-picker v-model="form.actualUpdateTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm" placeholder="选择实际剩余生效时间(精确到分)" popper-class="sales-order-date-popper" style="width:100%" :picker-options="actualTimePickerOptionsForOrder(form.id)" @change="val => onActualUpdateTimeChange(val, form.id)"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="getLatestAppTimeForOrder(form.id)" :gutter="24" style="margin-bottom: 12px;">
            <el-col :span="24">
              <div style="font-size:12px;color:#606266;line-height:1.6;background:#FEF0F0;padding:10px 14px;border-radius:4px;border:1px solid #FBC4C4;">
                <div>💡 <b>提示</b>：【实际剩余时间】指最新一次缴纳分期服务费（及手填实际剩余放行）的生效时刻。</div>
                <div style="margin-top:4px;color:#F56C6C;">• <b>填写要求</b>：填写的生效时间不可早于或等于本卡本年度最新提货时间（<b style="color:#F56C6C">{{ getLatestAppTimeForOrder(form.id) }}</b>），避免历史提货重复扣减！</div>
                <div style="margin-top:4px;color:#E6A23C;">• <b>温馨说明</b>：若本次未缴纳最新分期服务费，则无需修改此时间，可直接忽略本提示。</div>
              </div>
            </el-col>
          </el-row>
          <!-- 尊贵卡B 卡级：新出库已提额度 + 提货日期（放在额度后面，不在明细里）；剩余额度自动扣除 -->
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="新出库已提额度">
                <el-input-number v-model="form.newoutTakenAmount" :min="0" :precision="2" controls-position="right" style="width:100%" placeholder="该客户已通过新出库提走的额度"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="新出库提货日期">
                <el-date-picker v-model="form.newoutPickupDate" type="date" value-format="yyyy-MM-dd" placeholder="选择新出库提货日期" popper-class="sales-order-date-popper" style="width:100%"></el-date-picker>
                <div v-if="form.newoutPickupDate && form.serviceFeeStartDate" style="margin-top:8px;font-size:12px;line-height:1.5;">
                  <div style="color:#909399;margin-bottom:4px;">
                    当前服务年度：{{ getServiceYearWindow() }}
                  </div>
                  <div v-if="isNewoutPickupInWindow('B')" style="color:#67C23A;">
                    ✓ 提货日期在当前服务年度窗口内，会扣除本年度额度
                  </div>
                  <div v-else style="color:#E6A23C;">
                    ⚠ 此提货日期不在当前服务年度窗口内，未扣除
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </template>

        <el-row v-if="['尊贵卡B','尊贵卡C'].includes(form.category)" :gutter="24">
          <el-col :span="24">
            <el-form-item label="服务费已缴纳">
              <div v-if="serviceFeeYearOptions.length">
                <div v-for="opt in serviceFeeYearOptions" :key="opt.value" style="margin-bottom: 10px;">
                  <div style="display:flex;align-items:center;flex-wrap:wrap;background:#f8f9fa;padding:6px 12px;border-radius:4px;border:1px solid #ebeef5;">
                    <el-checkbox
                      :value="isYearPaid(opt.value)"
                      @change="val => handleYearCheckboxChange(opt.value, val)"
                      style="font-weight:600;color:#303133;">
                      {{ opt.label }}
                    </el-checkbox>
                    <div v-if="isYearPaid(opt.value)" style="margin-left:16px;display:flex;align-items:center;">
                      <span style="font-size:12px;color:#606266;margin-right:6px;font-weight:600;">结清状态：</span>
                      <el-switch
                        :value="isYearSettled(opt.value)"
                        @change="val => handleYearSettledChange(opt.value, val)"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        size="mini">
                      </el-switch>
                      <span v-if="isYearSettled(opt.value)" style="margin-left:8px;font-size:12px;font-weight:700;color:#13ce66;">✅ 已结清</span>
                      <span v-else style="margin-left:8px;font-size:12px;font-weight:700;color:#ff4949;">❌ 未结清</span>
                    </div>
                    <el-button type="text" size="mini" style="margin-left:auto;font-size:12px;" @click="toggleYearExpand(opt.value)">
                      <i :class="isYearExpanded(opt.value) ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                      {{ isYearExpanded(opt.value) ? '折叠服务费缴纳明细' : '展开服务费缴纳明细' }}
                      <span v-if="getYearPaymentsCount(opt.value) > 0" style="color:#409EFF;margin-left:4px;font-weight:600;">({{ getYearPaymentsCount(opt.value) }}笔 / ¥{{ getYearPaymentsTotal(opt.value).toFixed(2) }})</span>
                    </el-button>
                  </div>

                  <!-- 折叠展开面板：对应年份的服务费缴纳明细 -->
                  <div v-show="isYearExpanded(opt.value)"
                       style="margin-top:6px;padding:12px;background:#fcfcfc;border:1px dashed #dcdfe6;border-radius:4px;">
                    <div style="font-size:12px;font-weight:600;color:#606266;margin-bottom:8px;display:flex;justify-content:space-between;align-items:center;">
                      <span>
                        💳 {{ opt.value }}年度 服务费缴纳明细 
                        <span v-if="!isYearPaid(opt.value)" style="color:#f56c6c;font-weight:normal;margin-left:6px;">（需先勾选该年度已缴纳才可填写）</span>
                        <span v-else-if="isPastYear(opt.value)" style="color:#e6a23c;font-weight:normal;margin-left:6px;">（过去年份仅供查看，不可修改）</span>
                      </span>
                      <span style="color:#409EFF;">年度缴纳合计：¥{{ getYearPaymentsTotal(opt.value).toFixed(2) }}</span>
                    </div>
                    
                    <div v-for="(pItem, pIdx) in getYearPayments(opt.value)" :key="pIdx" style="display:flex;align-items:center;margin-bottom:8px;">
                      <el-date-picker v-model="pItem.payDate" type="date" value-format="yyyy-MM-dd" placeholder="缴费日期" size="mini" popper-class="sales-order-date-popper" style="width:140px;margin-right:8px;" :disabled="!isYearPaid(opt.value) || isPastYear(opt.value)"></el-date-picker>
                      <el-input-number v-model="pItem.amount" :min="0" :precision="2" controls-position="right" size="mini" placeholder="打款金额" style="width:130px;margin-right:8px;" :disabled="!isYearPaid(opt.value) || isPastYear(opt.value)"></el-input-number>
                      <el-input v-model="pItem.remark" placeholder="备注/打款凭证说明" size="mini" style="flex:1;margin-right:8px;" :disabled="!isYearPaid(opt.value) || isPastYear(opt.value)"></el-input>
                      <el-button v-if="isYearPaid(opt.value) && !isPastYear(opt.value)" type="text" icon="el-icon-delete" style="color:#f56c6c;" @click="removeYearPayment(opt.value, pIdx)"></el-button>
                    </div>
                    <div v-if="!getYearPayments(opt.value).length" style="color:#909399;font-size:12px;margin-bottom:6px;padding:4px 0;">暂无服务费缴纳记录</div>

                    <el-button v-if="isYearPaid(opt.value) && !isPastYear(opt.value)" size="mini" type="primary" plain icon="el-icon-plus" @click="addYearPayment(opt.value)">添加 {{ opt.value }} 年服务费缴纳明细</el-button>
                  </div>
                </div>
              </div>
              <span v-else style="color:#909399;font-size:12px;">请先选择合同服务起始日和合同服务终止日</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="附件">
          <el-button size="small" type="primary" icon="el-icon-camera" @click="scanVisible = true">附件</el-button>
          <span class="muted small" style="margin-left:10px;color:#909399;font-size:12px;">单个文件最大 100 MB</span>
          <div v-if="formSignList.length" class="agreement-preview">
            <div v-for="(u, i) in formSignList" :key="'sign'+i" class="agreement-item">
              <el-image
                v-if="isImageUrl(u)"
                :src="fullUrl(u)"
                :preview-src-list="formSignList.filter(x => isImageUrl(x)).map(x => fullUrl(x))"
                style="width:80px;height:80px;border-radius:4px;margin-right:10px"
                fit="cover"></el-image>
              <el-link v-else type="primary" :href="fullUrl(u)" target="_blank" rel="noopener" icon="el-icon-document">{{ fileShort(u) }}</el-link>
              <el-button size="mini" type="text" style="color:#f56c6c;margin-left:10px" @click="removeSign(i)">移除</el-button>
            </div>
          </div>
        </el-form-item>

        <el-divider content-position="left">
          <span class="divider-text">订单明细</span>
          <span v-if="form.category === '尊贵卡B'" style="margin-left:8px;color:#f56c6c;font-size:12px;font-weight:normal;">（尊贵卡B 仅作展示，不计入剩余金额/已提货等规则）</span>
        </el-divider>

        <el-row :gutter="24" style="margin-bottom: 8px;">
          <el-col :span="8">
            <el-form-item label="明细总金额">
              <div class="unit-wrap">
                <el-input :value="dialogTotalAmount" disabled></el-input>
                <span class="unit-suffix">元</span>
              </div>
            </el-form-item>
          </el-col>
          <el-col v-if="form.category !== '尊贵卡A'" :span="8">
            <el-form-item label="欠款" prop="debt">
              <div class="unit-wrap">
                <el-input-number v-model="form.debt" :min="0" :precision="2" controls-position="right" style="width:100%" placeholder="欠款"></el-input-number>
                <span class="unit-suffix">元</span>
              </div>
            </el-form-item>
          </el-col>
          <el-col v-if="['尊贵卡A','尊贵卡C'].includes(form.category)" :span="8">
            <el-form-item label="领取上限总金额">
              <div class="unit-wrap">
                <el-input :value="dialogQuotaTotalAmount" disabled title="所有明细中 领取上限 × 单价 之和"></el-input>
                <span class="unit-suffix">元</span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 还款计划列表（有欠款时显示）-->
        <div v-if="form.category !== '尊贵卡A' && Number(form.debt || 0) > 0" style="margin-top:20px">
          <el-divider content-position="left">
            <span style="color:#E6A23C;font-weight:600">还款计划（分期）</span>
          </el-divider>

          <div v-for="(plan, idx) in form.paymentPlans" :key="idx"
               style="margin-bottom:15px;padding:15px;border:1px solid #EBEEF5;border-radius:4px;background:#FAFAFA">
            <div style="display:flex;align-items:center;margin-bottom:10px">
              <span style="font-weight:600;color:#409EFF;margin-right:10px">第{{idx + 1}}期</span>

              <!-- 状态标记（编辑现有订单时显示）-->
              <template v-if="plan.id">
                <el-tag v-if="plan.status === 1" type="success" size="small" style="margin-right:5px">
                  ✅ 结清
                </el-tag>
                <el-tag v-else-if="plan.overdueFlag === 1" type="danger" size="small" style="margin-right:5px">
                  ❌ 逾期
                </el-tag>
                <el-tag v-else-if="Number(plan.paidAmount || 0) > 0" type="warning" size="small" style="margin-right:5px">
                  ⏳ 已还¥{{Number(plan.paidAmount).toFixed(2)}} / ¥{{Number(plan.expectedAmount).toFixed(2)}}
                </el-tag>
                <el-tag v-else type="info" size="small" style="margin-right:5px">
                  ⏸ 待还
                </el-tag>
              </template>

              <el-button v-if="form.paymentPlans.length > 1"
                         size="mini"
                         type="text"
                         icon="el-icon-delete"
                         style="color:#F56C6C;margin-left:auto"
                         @click="removePaymentPlan(idx)">删除</el-button>
            </div>
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="约定回款日期" label-width="110px">
                  <el-date-picker
                    :value="plan.expectedDate"
                    @input="val => { $set(plan, 'expectedDate', val); $forceUpdate(); }"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                    popper-class="sales-order-date-popper"
                    style="width:100%">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="约定回款金额" label-width="110px">
                  <div class="unit-wrap">
                    <el-input-number
                      v-model="plan.expectedAmount"
                      :min="0"
                      :precision="2"
                      controls-position="right"
                      style="width:100%"
                      placeholder="金额">
                    </el-input-number>
                    <span class="unit-suffix">元</span>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <el-button size="small"
                     type="primary"
                     plain
                     icon="el-icon-plus"
                     @click="addPaymentPlan"
                     style="width:100%">新增还款计划</el-button>

          <div style="margin-top:10px;padding:10px;background:#FFF7E6;border:1px solid #E6A23C;border-radius:4px;font-size:13px;color:#E6A23C">
            💡 <strong>信用卡分期模式</strong>：可设置多期还款计划。实际还款时按期数顺序自动分配，优先补齐早期欠款。
            <div style="margin-top:5px">
              总计约定：<strong>¥{{ totalPaymentPlans.toFixed(2) }}</strong> / 订单欠款：<strong>¥{{ Number(form.debt || 0).toFixed(2) }}</strong>
              <span v-if="totalPaymentPlans !== Number(form.debt || 0)" style="color:#F56C6C;margin-left:10px">
                ⚠️ 总计不等于欠款
              </span>
            </div>
          </div>
        </div>

        <!-- 订单明细列表 -->
        <div v-for="(d, idx) in form.details" :key="idx" class="detail-card" :class="{ 'detail-card--voided': ['尊贵卡A','尊贵卡C'].includes(form.category) && Number(d.voided) === 1 }"
             :style="{ marginTop: (form.category !== '尊贵卡A' && Number(form.debt || 0) > 0 && idx === 0) ? '25px' : '' }">
          <div v-if="['尊贵卡A','尊贵卡C'].includes(form.category) && Number(d.voided) === 1" class="void-stamp">已作废</div>
          <div class="detail-card-header">
            <span class="detail-index">销售订单 {{ idx + 1 }}</span>
            <span v-if="['送存货','尊贵卡A','尊贵卡C'].includes(form.category) && acTaken(d) > 0" class="detail-taken-hint">已提 {{ acTaken(d) }}{{ ['尊贵卡A','尊贵卡C'].includes(form.category) ? '（本年度）' : '' }}</span>
            <!-- 尊贵卡A/C：是否变更作废（开关恒可点=可逆）。变更后本行禁改、产品作废，提货看不到也提不了，不影响其它明细 -->
            <span v-if="['尊贵卡A','尊贵卡C'].includes(form.category)" class="detail-change-toggle">
              <span class="dc-toggle-label">是否变更：</span>
              <el-switch :value="d.voided" :active-value="1" :inactive-value="0" active-text="变更" inactive-text="不变更" active-color="#e74c3c" inactive-color="#c0c4cc" @change="val => onVoidToggle(d, val)"></el-switch>
            </span>
            <el-tooltip v-if="form.details.length > 1" :disabled="!detailDeleteDisabled(d)" :content="detailDeleteReason(d)" placement="top">
              <span style="display:inline-block">
                <el-button size="mini" type="text" icon="el-icon-delete" class="detail-remove" :disabled="detailDeleteDisabled(d)" @click="form.details.splice(idx, 1)">删除</el-button>
              </span>
            </el-tooltip>
          </div>
          <el-row :gutter="16">
            <el-col :span="24"><el-form-item label="产品名称" required>
              <el-select v-model="d.productId" filterable placeholder="选择产品" style="width: 100%" :disabled="nameDisabled(d)" @change="onProductChange(d)">
                <el-option v-for="p in productOpts" :key="p.id" :label="vipName(p.name, form.category)" :value="p.id"></el-option>
              </el-select>
            </el-form-item></el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="12"><el-form-item label="单价" required>
              <div class="unit-wrap">
                <el-input-number v-model="d.price" :min="0" :precision="2" controls-position="right" style="width:100%" disabled placeholder="选产品后自动带入"></el-input-number>
                <span class="unit-suffix">元</span>
              </div>
            </el-form-item></el-col>
            <el-col :span="12"><el-form-item label="数量" required>
              <div class="unit-wrap">
                <el-input-number v-model="d.quantity" :min="0" controls-position="right" style="width:100%" placeholder="请填写数量" :disabled="rowDisabled(d)" @change="recalcRow(d)"></el-input-number>
                <span class="unit-suffix">件</span>
              </div>
              <span v-if="['尊贵卡A','尊贵卡C'].includes(form.category)" style="color:#909399;font-size:12px;display:block;line-height:1.4;">每年标准领取量，跨年后领取上限按此重置</span>
            </el-form-item></el-col>
          </el-row>
          <!-- 非VIP（送存货/普通/礼品/试用/新出库）：赠送数量+补贴 一行，实付+存货 一行 -->
          <template v-if="!['尊贵卡A','尊贵卡B','尊贵卡C'].includes(form.category)">
            <el-row :gutter="16">
              <el-col :span="12"><el-form-item label="赠送数量">
                <div class="unit-wrap">
                  <el-input-number v-model="d.giftQuantity" :min="0" controls-position="right" style="width:100%" @change="recalcRow(d)"></el-input-number>
                  <span class="unit-suffix">件</span>
                </div>
              </el-form-item></el-col>
              <el-col :span="12"><el-form-item label="补贴金额">
                <div class="unit-wrap">
                  <el-input-number v-model="d.subsidyAmount" :precision="2" controls-position="right" style="width:100%" disabled placeholder="自动计算"></el-input-number>
                  <span class="unit-suffix">元</span>
                </div>
              </el-form-item></el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="12"><el-form-item label="实付金额" required>
                <div class="unit-wrap">
                  <el-input-number v-model="d.actualAmount" :min="0" :precision="2" controls-position="right" style="width:100%" placeholder="请填写实付" :disabled="rowDisabled(d)" @change="recalcRow(d)"></el-input-number>
                  <span class="unit-suffix">元</span>
                </div>
              </el-form-item></el-col>
              <el-col :span="12"><el-form-item label="存货数量" :required="form.category === '送存货'">
                <div class="unit-wrap">
                  <el-input-number v-model="d.stockQuantity" :min="0" controls-position="right" style="width:100%" placeholder="数量 + 赠送（可手动修改）" @change="d._stockManual = true"></el-input-number>
                  <span class="unit-suffix">件</span>
                </div>
              </el-form-item></el-col>
            </el-row>
          </template>
          <!-- 尊贵卡A/B/C：补贴金额 + 实付金额 一行 -->
          <template v-else>
            <el-row :gutter="16">
              <el-col :span="12"><el-form-item label="补贴金额">
                <div class="unit-wrap">
                  <el-input-number v-model="d.subsidyAmount" :precision="2" controls-position="right" style="width:100%" disabled placeholder="自动计算"></el-input-number>
                  <span class="unit-suffix">元</span>
                </div>
              </el-form-item></el-col>
              <el-col :span="12"><el-form-item label="实付金额" required>
                <div class="unit-wrap">
                  <el-input-number v-model="d.actualAmount" :min="0" :precision="2" controls-position="right" style="width:100%" placeholder="请填写实付" :disabled="rowDisabled(d)" @change="recalcRow(d)"></el-input-number>
                  <span class="unit-suffix">元</span>
                </div>
              </el-form-item></el-col>
            </el-row>
          </template>
          <!-- 尊贵卡A/C：显示「领取上限」 -->
          <el-row :gutter="16" v-if="['尊贵卡A','尊贵卡C'].includes(form.category)">
            <el-col :span="12"><el-form-item label="领取上限" required>
              <div class="unit-wrap">
                <el-input-number v-model="d.stockLimit" :min="0" controls-position="right" style="width:100%" placeholder="请填写领取上限" :disabled="rowDisabled(d)" @change="onStockLimitChange(d)"></el-input-number>
                <span class="unit-suffix">件</span>
              </div>
              <span style="color:#909399;font-size:12px;display:block;line-height:1.4;">本年度最多可领（≤数量），跨年自动恢复为数量</span>
            </el-form-item></el-col>
          </el-row>

          <!-- 尊贵卡C 专属：第一行 协议剩余 + 应该剩余；第二行 实际剩余 + 实际剩余时间 -->
          <template v-if="form.category === '尊贵卡C'">
            <el-row :gutter="16">
              <el-col :span="12"><el-form-item label="协议剩余">
                <div class="unit-wrap">
                  <el-input-number :value="d.quantity != null ? d.quantity : 0" :min="0" controls-position="right" style="width:100%" placeholder="等于数量" disabled></el-input-number>
                  <span class="unit-suffix">件</span>
                </div>
              </el-form-item></el-col>
              <el-col :span="12"><el-form-item label="应该剩余">
                <div class="unit-wrap">
                  <el-input-number :value="d.shouldRemaining != null ? d.shouldRemaining : (d.remainingPickup != null ? d.remainingPickup : (d.stockLimit != null ? d.stockLimit : (d.quantity || 0)))" :min="0" controls-position="right" style="width:100%" disabled placeholder="剩余可领取件数"></el-input-number>
                  <span class="unit-suffix">件</span>
                </div>
              </el-form-item></el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="12"><el-form-item label="实际剩余">
                <div class="unit-wrap">
                  <el-input-number v-model="d.actualRemaining" :min="0" :max="computeShouldRemaining(d)" controls-position="right" style="width:100%" placeholder="手填实际放行件数" :disabled="rowDisabled(d)" @change="val => onActualRemainingChange(d, val)"></el-input-number>
                  <span class="unit-suffix">件</span>
                </div>
              </el-form-item></el-col>
              <el-col :span="12"><el-form-item label="实际剩余时间">
                <el-date-picker v-model="d.actualUpdateTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm" placeholder="选择实际剩余生效时间(精确到分)" popper-class="sales-order-date-popper" style="width:100%" :disabled="rowDisabled(d)" :picker-options="actualTimePickerOptionsForProduct(form.id, d.productId)" @change="val => onActualUpdateTimeChange(val, form.id, d)"></el-date-picker>
              </el-form-item></el-col>
            </el-row>
            <el-row v-if="getLatestAppTimeForProduct(form.id, d.productId)" :gutter="16" style="margin-bottom: 12px;">
              <el-col :span="24">
                <div style="font-size:12px;color:#606266;line-height:1.6;background:#FEF0F0;padding:10px 14px;border-radius:4px;border:1px solid #FBC4C4;">
                  <div>💡 <b>提示</b>：【实际剩余时间】指最新一次缴纳分期服务费（及手填实际剩余放行）的生效时刻。</div>
                  <div style="margin-top:4px;color:#F56C6C;">• <b>填写要求</b>：填写的生效时间不可早于或等于本产品本年度最新提货时间（<b style="color:#F56C6C">{{ getLatestAppTimeForProduct(form.id, d.productId) }}</b>），避免历史提货重复扣减！</div>
                  <div style="margin-top:4px;color:#E6A23C;">• <b>温馨说明</b>：若本次未缴纳最新分期服务费，则无需修改此时间，可直接忽略本提示。</div>
                </div>
              </el-col>
            </el-row>
          </template>
          <!-- 送存货/尊贵卡A·C：新出库已提数量 + 提货日期（按产品，放明细里）；尊贵卡B 的已提额度在卡级（额度后面） -->
          <el-row :gutter="16" v-if="['送存货','尊贵卡A','尊贵卡C'].includes(form.category)">
            <el-col :span="12"><el-form-item label="新出库已提数量">
              <div class="unit-wrap">
                <el-input-number v-model="d.newoutTakenQuantity" :min="0" controls-position="right" style="width:100%" placeholder="该客户已通过新出库提走的数量" :disabled="rowDisabled(d)" @change="recalcRow(d)"></el-input-number>
                <span class="unit-suffix">件</span>
              </div>
              <span style="color:#909399;font-size:12px;display:block;line-height:1.4;">按新出库提货日期计入对应年度，仅扣除本年度窗口内的数量</span>
            </el-form-item></el-col>
            <el-col :span="12"><el-form-item label="新出库提货日期">
              <el-date-picker v-model="d.pickupDate" type="date" value-format="yyyy-MM-dd" placeholder="选择新出库提货日期" popper-class="sales-order-date-popper" style="width:100%" :disabled="rowDisabled(d)" @change="recalcRow(d)"></el-date-picker>
              <div v-if="d.pickupDate && form.serviceFeeStartDate" style="margin-top:8px;font-size:12px;line-height:1.5;">
                <div style="color:#909399;margin-bottom:4px;">
                  当前服务年度：{{ getServiceYearWindow() }}
                </div>
                <div v-if="isNewoutPickupInWindow('AC', d)" style="color:#67C23A;">
                  ✓ 提货日期在当前服务年度窗口内，会扣除本年度可领取数量
                </div>
                <div v-else style="color:#E6A23C;">
                  ⚠ 此提货日期不在当前服务年度窗口内，未扣除
                </div>
              </div>
            </el-form-item></el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="24"><el-form-item label="备注">
              <el-input v-model="d.remark" type="textarea" :rows="2" placeholder="本条明细的备注" :disabled="rowDisabled(d)"></el-input>
            </el-form-item></el-col>
          </el-row>
        </div>
        <el-button size="small" type="primary" plain icon="el-icon-plus" @click="addDetail" style="margin-bottom: 12px;">添加一条明细</el-button>
        <!-- 订单备注 -->
        <el-row :gutter="16" style="margin-top: 6px;">
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input v-model="form.remark" type="textarea" :rows="2" placeholder="请输入备注" maxlength="500" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer-row">
        <span v-if="form.id" class="footer-modify-date">
          <span class="muted small" style="margin-right:6px">修改/变更时间</span>
          <el-date-picker
            v-model="form.modifyDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="必填"
            size="small"
            popper-class="sales-order-date-popper"
            style="width:160px">
          </el-date-picker>
        </span>
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="success" @click="handleSubmit">保存</el-button>
      </div>
    </el-dialog>

    <gaopaiyi-scanner :visible.sync="scanVisible" biz-type="agreement" @uploaded="onAgreementScanned"></gaopaiyi-scanner>
    <agreement-change-log-drawer :visible.sync="agrLogVisible" biz-type="ORDER" :biz-id="agrLogId" title="销售订单附件变更记录"></agreement-change-log-drawer>

    <!-- 登记回款弹窗（信用卡模式）-->
    <el-dialog title="登记回款" :visible.sync="debtDialog.visible" width="900px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form label-width="120px" size="small">
        <!-- 当前欠款 -->
        <el-form-item label="当前欠款">
          <span style="font-size:20px;color:#E6A23C;font-weight:bold">¥{{ Number(debtDialog.debt || 0).toFixed(2) }}</span>
        </el-form-item>

        <!-- 还款计划表格 -->
        <div v-if="debtDialog.plans && debtDialog.plans.length > 0" style="margin-bottom:20px;padding:0 20px">
          <div style="font-size:14px;color:#303133;font-weight:bold;margin-bottom:10px">还款计划</div>
          <div style="width:819px;overflow-x:auto">
            <el-table :data="debtDialog.plans" border size="mini">
            <el-table-column label="期数" width="70" align="center">
              <template slot-scope="scope">
                <el-tag size="mini">第{{scope.row.period}}期</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="约定日期" width="110" align="center" prop="expectedDate"></el-table-column>
            <el-table-column label="应还" width="90" align="right">
              <template slot-scope="scope">¥{{scope.row.expectedAmount}}</template>
            </el-table-column>
            <el-table-column label="已还" width="90" align="right">
              <template slot-scope="scope">¥{{scope.row.paidAmount}}</template>
            </el-table-column>
            <el-table-column label="还欠" width="100" align="right">
              <template slot-scope="scope">
                <span style="color:#F56C6C;font-weight:bold">¥{{(scope.row.expectedAmount - scope.row.paidAmount).toFixed(2)}}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="90" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status === 1 || (scope.row.paidAmount >= scope.row.expectedAmount)" type="success" size="mini">已还</el-tag>
                <el-tag v-else-if="Number(scope.row.paidAmount || 0) > 0" type="warning" size="mini">未还清</el-tag>
                <el-tag v-else type="info" size="mini">待还</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="逾期标记" width="100" align="center">
              <template slot-scope="scope">
                <el-tag v-if="isOverdue(scope.row)" type="danger" size="mini" effect="dark">
                  <i class="el-icon-warning"></i> 逾期
                </el-tag>
                <el-tag v-else-if="isBeforeExpected(scope.row)" type="info" size="mini">未到期</el-tag>
                <el-tag v-else type="success" size="mini">未逾期</el-tag>
              </template>
            </el-table-column>
          </el-table>
          </div>
          <div style="margin-top:10px;padding:10px;background:#FFF7E6;border:1px solid #E6A23C;border-radius:4px;font-size:13px;color:#E6A23C;width:819px">
            💡 <strong>信用卡还款模式</strong>：本次回款会按期数顺序自动分配，优先补齐早期欠款
          </div>
        </div>

        <!-- 当前期数信息（第一个未完成的期数）-->
        <el-form-item label="当前还款期数" v-if="currentPlan">
          <div style="padding:12px;background:#F5F7FA;border:1px solid #DCDFE6;border-radius:4px">
            <div style="margin-bottom:8px">
              <el-tag type="primary" size="medium">第{{currentPlan.period}}期</el-tag>
              <span style="margin-left:10px;font-size:14px;color:#606266">
                约定：<strong>{{currentPlan.expectedDate}}</strong> 还 <strong style="color:#E6A23C">¥{{currentPlan.expectedAmount}}</strong>
              </span>
            </div>
            <div style="font-size:13px;color:#909399">
              已还：<span style="color:#67C23A;font-weight:bold">¥{{currentPlan.paidAmount}}</span>
              <span style="margin:0 10px">|</span>
              还欠：<span style="color:#F56C6C;font-weight:bold">¥{{(currentPlan.expectedAmount - currentPlan.paidAmount).toFixed(2)}}</span>
            </div>
          </div>
        </el-form-item>

        <!-- 本次回款金额 -->
        <el-form-item label="本次回款金额">
          <el-input-number
            v-model="debtDialog.payment"
            :min="0"
            :max="Number(debtDialog.debt || 0)"
            :precision="2"
            controls-position="right"
            style="width:100%"
            placeholder="实际回款金额"
            @change="previewPaymentAllocation">
          </el-input-number>
        </el-form-item>

        <!-- 当前期数还款效果预览 -->
        <el-form-item label="本期还款效果" v-if="debtDialog.payment > 0 && currentPlan">
          <div style="padding:12px;background:#FFF7E6;border:1px solid #E6A23C;border-radius:4px">
            <div style="font-size:14px;color:#E6A23C;margin-bottom:5px">
              <strong>第{{currentPlan.period}}期</strong>：
              应还 <strong>¥{{currentPlan.expectedAmount}}</strong>，
              已还 <strong>¥{{currentPlan.paidAmount}}</strong>，
              本次还 <strong style="color:#67C23A">¥{{Math.min(debtDialog.payment, currentPlan.expectedAmount - currentPlan.paidAmount).toFixed(2)}}</strong>
            </div>
            <div style="font-size:15px;font-weight:bold;margin-top:8px">
              <template v-if="currentPlan.paidAmount + debtDialog.payment >= currentPlan.expectedAmount">
                → 实还 <span style="color:#67C23A">¥{{(currentPlan.paidAmount + Math.min(debtDialog.payment, currentPlan.expectedAmount - currentPlan.paidAmount)).toFixed(2)}}</span>
                <span style="color:#67C23A;margin-left:8px">✅ 本期结清</span>
              </template>
              <template v-else>
                → 实还 <span style="color:#E6A23C">¥{{(currentPlan.paidAmount + debtDialog.payment).toFixed(2)}}</span>
                <span style="color:#F56C6C;margin-left:8px">❌ 欠¥{{(currentPlan.expectedAmount - currentPlan.paidAmount - debtDialog.payment).toFixed(2)}}</span>
              </template>
            </div>
          </div>
        </el-form-item>

        <!-- 分配预览（所有期数）-->
        <el-form-item label="完整分配预览" v-if="debtDialog.payment > 0 && paymentAllocation.length > 1">
          <div style="padding:12px;background:#F0F9FF;border:1px solid #91D5FF;border-radius:4px">
            <div style="margin-bottom:8px;font-size:13px;color:#1890FF;font-weight:bold">
              💰 本次¥{{ Number(debtDialog.payment).toFixed(2) }}将这样分配：
            </div>
            <div v-for="(alloc, index) in paymentAllocation" :key="index"
                 style="margin-bottom:6px;padding:6px;background:white;border-radius:3px;font-size:13px">
              <span style="color:#409EFF;font-weight:bold">第{{alloc.period}}期</span>：
              分配 <span style="color:#67C23A;font-weight:bold">¥{{alloc.amount.toFixed(2)}}</span>
              <span v-if="alloc.complete" style="color:#67C23A;margin-left:8px">✅ 结清</span>
              <span v-else style="color:#E6A23C;margin-left:8px">❌ 还欠¥{{alloc.remaining.toFixed(2)}}</span>
            </div>
          </div>
        </el-form-item>

        <!-- 本次回款日期 -->
        <el-form-item label="本次回款日期">
          <el-date-picker
            :value="debtDialog.paymentDate"
            @input="val => { $set(debtDialog, 'paymentDate', val); $forceUpdate(); }"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择回款日期"
            popper-class="sales-order-date-popper"
            style="width:100%">
          </el-date-picker>
        </el-form-item>

        <!-- 剩余欠款 -->
        <el-form-item label="剩余欠款">
          <span style="font-size:18px;font-weight:bold"
                :style="{color: remainingDebtAfterPayment === 0 ? '#67C23A' : '#F56C6C'}">
            ¥{{ remainingDebtAfterPayment.toFixed(2) }}
            <span v-if="remainingDebtAfterPayment === 0 && debtDialog.payment > 0"
                  style="font-size:14px;margin-left:10px">🎉 已结清</span>
          </span>
          <div v-if="remainingDebtAfterPayment > 0" style="margin-top:8px;font-size:12px;color:#909399">
            💡 如需调整还款计划，请编辑订单
          </div>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button size="small" @click="debtDialog.visible = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitDebt">确定登记</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import GaopaiyiScanner from '../components/GaopaiyiScanner.vue'
import AgreementChangeLogDrawer from '../components/AgreementChangeLogDrawer.vue'

export default {
  name: 'SalesOrder',
  components: { GaopaiyiScanner, AgreementChangeLogDrawer },
  // 嵌入模式：传入某个客户对象时，整页只针对该客户（列表按 customerId 过滤、隐藏外层卡片头与搜索栏、新建订单锁定客户）
  props: {
    embeddedCustomer: { type: Object, default: null }
  },
  data() {
    return {
      debtDialog: {
        visible: false,
        row: null,
        debt: 0,
        payment: 0,
        paymentDate: '',
        plans: [],  // 未完成的还款计划列表
        nextExpectedDate: null,  // 下次约定日期
        nextExpectedAmount: null  // 下次约定金额
      },
      paymentAllocation: [],  // 分配预览结果
      today: new Date().toISOString().slice(0, 10),
      scanVisible: false,
      agrLogVisible: false,
      agrLogId: null,
      searchForm: { customerName: '', productName: '', category: '', stockType: '', dormantStatus: '', saleDateRange: null },
      orderList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 嵌入模式：当前客户全部销售订单的明细总金额、欠款汇总
      customerTotalAmount: 0,
      customerTotalDebt: 0,
      dialogVisible: false,
      form: this.emptyForm(),
      originActualQuotaRemaining: 0,
      originActualRemainingList: [],
      originActualUpdateTime: '',
      originDetailActualUpdateTimeList: [],
      customerOpts: [],
      productOpts: [],
      applicableTypeOptions: [],
      stockTypeOptions: ['普通存货', '品鉴存货'],
      categoryOptions: ['送存货', '尊贵卡A', '尊贵卡B', '尊贵卡C'],
      // 展开行 id 列表：自动刷新替换 orderList 时保留展开态
      expandedRowKeys: [],
      expandedServiceFeeYears: [], // 正在展开打款明细的服务费年份列表
      changeLogsMap: {},
      attachLogsMap: {},
      detailLogsMap: {},
      paymentPlansMap: {}, // 订单还款计划映射表
      originActualQuotaRemaining: 0,
      originActualRemainingList: [],
      orderAppsForLimitMap: {}
    }
  },
  mounted() {
    this.loadList()
    this.loadApplicableTypes()
    axios.get('/customer/list').then(res => { this.customerOpts = res.data || [] })
    axios.get('/product/list').then(res => { this.productOpts = res.data || [] })
    // 每 10 秒静默刷新一次列表，让"剩余可领取数量/已领取/在途"等动态字段跟上提货申请变化。
    // 弹窗打开时跳过，避免覆盖用户正在填的草稿。
    this._refreshTimer = setInterval(() => {
      if (!this.dialogVisible) this.loadList()
    }, 10000)
  },
  beforeDestroy() {
    if (this._refreshTimer) { clearInterval(this._refreshTimer); this._refreshTimer = null }
  },
  computed: {
    embedded() { return !!(this.embeddedCustomer && this.embeddedCustomer.id) },
    /** 动态已缴服务费总额 */
    serviceFeeTotalPaidAmount() {
      if (!Array.isArray(this.form.serviceFeePaymentList)) return 0
      return this.form.serviceFeePaymentList.reduce((sum, item) => sum + (Number(item.amount) || 0), 0)
    },
    /** 登记回款弹窗：当前欠款 - 本次回款 = 剩余欠款（≥0） */
    remainingDebtAfterPayment() {
      const debt = Number(this.debtDialog.debt || 0)
      const pay = Number(this.debtDialog.payment || 0)
      return Math.max(0, +(debt - pay).toFixed(2))
    },
    dialogTotalAmount() {
      // 已变更/已作废明细（voided===1）不计入明细总金额
      return ((this.form.details || [])
        .filter(d => Number(d.voided) !== 1)
        .reduce((s, d) => s + (Number(d.actualAmount) || 0), 0)).toFixed(2)
    },
    // 还款计划总计约定金额
    totalPaymentPlans() {
      return (this.form.paymentPlans || [])
        .reduce((sum, plan) => sum + (Number(plan.expectedAmount) || 0), 0)
    },
    // 登记回款弹窗：当前期数（第一个未完成的期数）
    currentPlan() {
      const plans = this.debtDialog.plans || []
      if (!plans.length) return null
      // 找第一个未完成的（status=0）
      return plans.find(p => p.status === 0) || null
    },
    // 领取上限总金额（仅尊贵卡A/C）= Σ(领取上限 × 单价)，已变更/已作废明细 voided===1 不计入
    dialogQuotaTotalAmount() {
      return ((this.form.details || [])
        .filter(d => Number(d.voided) !== 1)
        .reduce(
          (s, d) => s + (Number(d.stockLimit) || 0) * (Number(d.price) || 0), 0)).toFixed(2)
    },
    isVipCategory() {
      return ['尊贵卡A', '尊贵卡B', '尊贵卡C'].includes(this.form.category)
    },
    serviceTermRange() {
      const start = (this.form.serviceFeeStartDate || '').slice(0, 10)
      const end = (this.form.serviceFeeEndDate || '').slice(0, 10)
      if (!start || !end) return ''
      return start + ' 至 ' + end
    },
    // 派生服务费起始日 = 合同起始日 + 免服务期月数
    derivedServiceFeeStart() {
      return this.computeServiceFeeStart(this.form.serviceFeeStartDate, this.form.freeServiceMonths)
    },
    serviceFeeYearOptions() {
      // 年度槽起点 = 派生服务费起始日（合同起始日 + 免服务期月）。
      // 永续卡：渲染槽数动态 = max(已勾最大年, 当前年) + 5 年缓冲，足够手动续费时再继续勾。
      const start = this.computeServiceFeeStart(this.form.serviceFeeStartDate, this.form.freeServiceMonths)
      if (!start) return []
      const sd = new Date(start.replace(/-/g, '/'))
      if (isNaN(sd.getTime())) return []
      const cn = d => `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`
      const startYear = sd.getFullYear()
      const checked = (this.form.serviceFeePaidYears || []).filter(n => !isNaN(Number(n))).map(Number)
      const maxChecked = checked.length ? Math.max(...checked) : startYear
      const targetYear = Math.max(maxChecked, new Date().getFullYear()) + 5
      const opts = []
      let cur = new Date(sd.getTime())
      while (cur.getFullYear() <= targetYear) {
        const next = new Date(cur.getTime())
        next.setFullYear(next.getFullYear() + 1)
        const nextEnd = new Date(next.getTime() - 86400000)
        opts.push({ value: cur.getFullYear(), label: `${cn(cur)} ~ ${cn(nextEnd)}` })
        cur = next
        if (opts.length >= 100) break
      }
      return opts
    },
    apiOrigin() {
      const base = (axios.defaults.baseURL || '').replace(/\/api\/?$/, '')
      return base || ''
    },
    uploadUrl() {
      return (axios.defaults.baseURL || '') + '/file/upload'
    },
    uploadHeaders() {
      const t = sessionStorage.getItem('token')
      return t ? { Authorization: 'Bearer ' + t } : {}
    },
    formAgreementList() {
      return this.agreementList(this.form)
    },
    formSignList() {
      return this.signList(this.form)
    },
    isActualRemainingModified() {
      if (!this.form || !['尊贵卡B', '尊贵卡C'].includes(this.form.category)) return false
      if (this.form.category === '尊贵卡B') {
        return Number(this.form.actualQuotaRemaining || 0) !== Number(this.originActualQuotaRemaining || 0)
      }
      if (this.form.category === '尊贵卡C') {
        const curList = (this.form.details || []).map(d => Number(d.actualRemaining || 0))
        const oldList = (this.originActualRemainingList || []).map(v => Number(v || 0))
        if (curList.length !== oldList.length) return true
        return curList.some((v, idx) => v !== oldList[idx])
      }
      return false
    }
  },
  watch: {
    'embeddedCustomer.id': {
      handler(newId) {
        if (newId) this.loadList()
      },
      immediate: true
    },
    // B/C 卡：服务费已缴 / 服务费起始日 / 免期月数 任一变化 → 自动同步订单 dormantStatus
    // 当年已缴 → 激活(0)；未缴(含免期内) → 休眠(1)；提交订单时一起写库
    'form.serviceFeePaidYears'() { this.syncDormantFromPaid() },
    'form.serviceFeeStartDate'() { this.syncDormantFromPaid() },
    'form.freeServiceMonths'() { this.syncDormantFromPaid() },
    // 欠款变化时，初始化还款计划
    'form.debt': {
      handler(newVal) {
        if (newVal > 0) {
          // 如果还款计划为空，自动添加第1期（默认一次性还清）
          if (!this.form.paymentPlans || this.form.paymentPlans.length === 0) {
            this.$set(this.form, 'paymentPlans', [{
              expectedDate: '',
              expectedAmount: Number(newVal)
            }])
          }
        } else {
          this.$set(this.form, 'paymentPlans', [])
        }
      },
      immediate: false
    },
    // 弹窗关闭时清空 form，避免数据残留
    dialogVisible(newVal) {
      if (!newVal) {
        console.log('🔄 弹窗已关闭，清空表单数据')
        this.form = this.emptyForm()
      }
    }
  },
  methods: {
    dormantTagType(statusText) {
      if (statusText === '休眠') return 'danger'
      if (statusText === '缓冲期') return 'warning'
      return 'success'  // 激活
    },
    // 判断还款计划是否逾期（一旦逾期，永久标记）
    isOverdue(plan) {
      // 1. 如果已经标记为逾期，永久显示（即使后来还清了）
      if (plan.overdueFlag === 1) return true

      // 2. 实时判断：约定日期已过 = 曾经逾期
      if (!plan.expectedDate) return false
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const expectedDate = new Date(plan.expectedDate)
      expectedDate.setHours(0, 0, 0, 0)

      // 约定日期已过，检查是否按时还款
      if (expectedDate < today) {
        // 如果没有首次还款记录，或者首次还款晚于约定日期 = 逾期
        if (!plan.firstPaymentDate) {
          // 没有还款记录，且约定日期已过 = 逾期
          return true
        }
        const firstPaymentDate = new Date(plan.firstPaymentDate)
        firstPaymentDate.setHours(0, 0, 0, 0)
        // 首次还款日期 > 约定日期 = 逾期（即使后来还清了）
        return firstPaymentDate > expectedDate
      }

      return false
    },

    // 计算当前服务年度窗口
    getServiceYearWindow() {
      if (!this.form.serviceFeeStartDate) return '-'
      const startDate = new Date(this.form.serviceFeeStartDate)
      const today = new Date()

      // 计算已过整年数
      let yearsPassed = today.getFullYear() - startDate.getFullYear()
      const monthDiff = today.getMonth() - startDate.getMonth()
      const dayDiff = today.getDate() - startDate.getDate()

      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        yearsPassed--
      }

      // 如果今天还没到合同起始日
      if (yearsPassed < 0) return '-'

      // 计算窗口起始日
      const windowStart = new Date(startDate)
      windowStart.setFullYear(windowStart.getFullYear() + yearsPassed)

      // 计算窗口结束日（+1年 - 1天，用于显示格式化）
      const windowEnd = new Date(windowStart)
      windowEnd.setFullYear(windowEnd.getFullYear() + 1)
      windowEnd.setDate(windowEnd.getDate() - 1)

      const formatDate = (d) => {
        const year = d.getFullYear()
        const month = String(d.getMonth() + 1).padStart(2, '0')
        const day = String(d.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      }

      return `${formatDate(windowStart)} ~ ${formatDate(windowEnd)}`
    },

    // 判断新出库提货日期是否在当前服务年度窗口内
    isNewoutPickupInWindow(type, detail) {
      const pickupDate = type === 'B' ? this.form.newoutPickupDate : (detail ? detail.pickupDate : null)
      if (!pickupDate || !this.form.serviceFeeStartDate) return false

      const startDate = new Date(this.form.serviceFeeStartDate)
      const today = new Date()

      // 计算已过整年数
      let yearsPassed = today.getFullYear() - startDate.getFullYear()
      const monthDiff = today.getMonth() - startDate.getMonth()
      const dayDiff = today.getDate() - startDate.getDate()

      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        yearsPassed--
      }

      // 如果今天还没到合同起始日
      if (yearsPassed < 0) return false

      // 计算窗口起始日
      const windowStart = new Date(startDate)
      windowStart.setFullYear(windowStart.getFullYear() + yearsPassed)

      // 计算窗口结束日（+1年）
      const windowEnd = new Date(windowStart)
      windowEnd.setFullYear(windowEnd.getFullYear() + 1)

      // 判断提货日期是否在窗口内
      const pickup = new Date(pickupDate)
      return pickup >= windowStart && pickup < windowEnd
    },

    // 判断是否未到期（约定日期还没到）
    isBeforeExpected(plan) {
      if (!plan.expectedDate) return false
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const expectedDate = new Date(plan.expectedDate)
      expectedDate.setHours(0, 0, 0, 0)
      return expectedDate > today
    },

    // 类型 + 卡序号：仅尊贵卡A/B/C 带序号（"尊贵卡A2"）；其它类别原样返回
    vipCardLabel(category, cardSeq) {
      if (!category) return ''
      if (category === '产品试用' || category === '试用') return '试用'
      const isVip = category === '尊贵卡A' || category === '尊贵卡B' || category === '尊贵卡C'
      if (!isVip) return category
      if (cardSeq == null || cardSeq === '') return category
      return category + cardSeq
    },
    // 当前年度槽起点 = 服务费起始日 + 已过整年；免期内返回 null（视为休眠态）
    currentServiceYear() {
      if (!['尊贵卡B','尊贵卡C'].includes(this.form.category)) return null
      const feeStartStr = this.computeServiceFeeStart(this.form.serviceFeeStartDate, this.form.freeServiceMonths)
      if (!feeStartStr) return null
      const parts = feeStartStr.split('-').map(Number)
      const feeStart = new Date(parts[0], parts[1] - 1, parts[2])
      const today = new Date(); today.setHours(0, 0, 0, 0)
      if (today.getTime() < feeStart.getTime()) return null // 免期内
      let cur = new Date(feeStart.getTime())
      while (true) {
        const next = new Date(cur.getTime())
        next.setFullYear(next.getFullYear() + 1)
        if (next > today) break
        cur = next
      }
      return cur.getFullYear()
    },
    syncDormantFromPaid() {
      if (!['尊贵卡B','尊贵卡C'].includes(this.form.category)) return
      const curYear = this.currentServiceYear()
      if (curYear == null) {
        // 业务调整：免期内可正常提货，dormantStatus=0（激活）；无服务费起始日同样视为激活
        if (this.form.dormantStatus !== 0) this.form.dormantStatus = 0
        return
      }
      const paid = (this.form.serviceFeePaidYears || []).map(Number)
      const target = paid.includes(curYear) ? 0 : 2
      if (this.form.dormantStatus !== target) this.form.dormantStatus = target
    },
    loadApplicableTypes() {
      axios.get('/applicable-type/list').then(res => {
        const list = Array.isArray(res.data) ? res.data : []
        this.applicableTypeOptions = list.filter(item => item.enabled === 1 || item.enabled === undefined)
      }).catch(() => {
        this.applicableTypeOptions = []
      })
    },
    onCategoryChange(val) {
      if (val === '送存货') {
        if (!this.form.stockType) {
          this.$set(this.form, 'stockType', '普通存货')
        }
      } else {
        this.$set(this.form, 'stockType', '')
        this.$set(this.form, 'applicableTypeId', null)
        this.$set(this.form, 'applicableTypeName', '')
      }
    },
    onStockTypeChange(val) {
      if (val !== '品鉴存货' && val !== '试用存货') {
        this.$set(this.form, 'applicableTypeId', null)
        this.$set(this.form, 'applicableTypeName', '')
      }
    },
    onApplicableTypeChange(val) {
      const found = (this.applicableTypeOptions || []).find(x => x.id === val)
      this.$set(this.form, 'applicableTypeName', found ? found.name : '')
    },
    emptyForm() {
      return {
        id: null, customerId: null, customerName: '', status: 0, type: 'normal', category: '',
        stockType: '', applicableTypeId: null, applicableTypeName: '',
        customerGender: '', customerPhone: '', customerAddress: '', customerIdCard: '', customerAge: undefined,
        freeServicePeriod: '', freeServiceMonths: 24, serviceFeeStartDate: '', serviceFeeEndDate: '', serviceFeePaidYears: [], serviceFeePaymentList: [], expiryWarningDays: undefined, quotaLimit: undefined, dormantStatus: 0,
        shouldQuotaRemaining: undefined, actualQuotaRemaining: 0,
        totalAmount: 0, debt: 0, paymentPlans: [],
        remark: '', agreementUrl: '', signFile: '', vipBRemaining: null, _cachedOnlineTaken: undefined,
        newoutTakenAmount: 0, newoutPickupDate: '',
        saleDate: new Date().toISOString().slice(0, 10),
        modifyDate: '',
        details: [this.emptyDetail()]
      }
    },
    // 用户点击展开/收起时同步 expandedRowKeys，loadList 后 el-table 据此恢复展开态。
    // expand-change 第二参数：使用 expand-row-keys 时是 boolean；否则是 expandedRows 数组——两种都兼容。
    onExpandChange(row, expandedOrRows) {
      const id = row && row.id
      if (id == null) return
      let expanded
      if (typeof expandedOrRows === 'boolean') {
        expanded = expandedOrRows
      } else {
        expanded = Array.isArray(expandedOrRows) && expandedOrRows.some(r => r && r.id === id)
      }
      if (expanded) {
        if (!this.expandedRowKeys.includes(id)) this.expandedRowKeys.push(id)
        this.loadChangeLog(id)
        this.loadAttachLog(id)
        this.loadPaymentPlans(id)
      } else {
        this.expandedRowKeys = this.expandedRowKeys.filter(k => k !== id)
      }
    },
    // 加载订单欠款变更记录（专用接口 /agreement-log/order-debt-log）
    // 展开里按真实操作顺序排（自增 id 降序，最新的在最前），不受"回款时间"等可选时间影响
    loadChangeLog(orderId) {
      axios.get('/agreement-log/order-debt-log', { params: { orderId } }).then(res => {
        const data = (res.data || []).slice()
          .sort((a, b) => (b.id || 0) - (a.id || 0))
          .map(l => ({ ...l, _debt: this.parseDebtLog(l) }))
        this.$set(this.changeLogsMap, orderId, data)
      }).catch(() => {})
    },
    // 解析欠款变更记录正文：拆出 变更后欠款 / 回款时间 / 回款金额（登记回款写入；修改/变更时间走 modifyTime 列）
    parseDebtLog(log) {
      const parts = String(log && log.newValue || '').split('|').map(s => s.trim())
      const out = { amount: parts[0] || '0', paymentTime: '', paymentAmount: '' }
      for (const p of parts.slice(1)) {
        if (p.indexOf('回款时间') === 0) out.paymentTime = p.replace('回款时间', '').trim()
        else if (p.indexOf('回款金额') === 0) out.paymentAmount = p.replace('回款金额', '').trim()
      }
      return out
    },
    // 加载订单还款计划
    loadPaymentPlans(orderId) {
      axios.get(`/order/payment-plan/all/${orderId}`).then(res => {
        if (res.data && res.data.success) {
          const plans = (res.data.data || []).sort((a, b) => a.period - b.period)
          this.$set(this.paymentPlansMap, orderId, plans)
        } else {
          this.$set(this.paymentPlansMap, orderId, [])
        }
      }).catch(() => {
        this.$set(this.paymentPlansMap, orderId, [])
      })
    },
    // 加载订单附件（agreementUrl）变更记录：action ∈ {新增/替换/删除}；同时拆出"明细修改"到 detailLogsMap
    loadAttachLog(orderId) {
      axios.get('/agreement-log', { params: { bizType: 'ORDER', bizId: orderId } }).then(res => {
        // 展开里按真实操作顺序排（自增 id 降序，最新的在最前）
        const all = (res.data || []).slice().sort((a, b) => (b.id || 0) - (a.id || 0))
        const filtered = all.filter(l => ['新增', '替换', '删除'].includes(l.action))
        this.$set(this.attachLogsMap, orderId, filtered)
        const details = all.filter(l => l.action === '明细修改' || l.action === '额度修改' || l.action === '剩余金额修改')
        // 按 title 匹配做 diff：
        //  - 新明细在旧里没出现 → isNew (绿)
        //  - 旧明细在新里没出现 → deleted (红)
        //  - 双方都有但字段不同 → changed (橙)，字段级 changed=true
        for (const log of details) {
          const oldBlocks = this.parseDetailBlocksRaw(log.oldValue)
          const newBlocks = this.parseDetailBlocksRaw(log.newValue)
          const oldMap = {}, newMap = {}
          for (const b of oldBlocks) oldMap[b.key] = b
          for (const b of newBlocks) newMap[b.key] = b
          const norm = v => {
            if (v == null) return ''
            const s = String(v).replace(/^¥/, '').trim()
            const n = Number(s)
            return !isNaN(n) && s !== '' ? String(n) : s
          }
          for (const nb of newBlocks) {
            const ob = oldMap[nb.key]
            if (!ob) {
              nb.isNew = true
              for (const f of nb.fields) f.changed = false
            } else {
              let anyChanged = false
              for (const f of nb.fields) {
                f.changed = norm(ob.fieldsMap[f.k]) !== norm(f.v)
                if (f.changed) anyChanged = true
              }
              nb.isChanged = anyChanged
            }
          }
          for (const ob of oldBlocks) {
            ob.deleted = !newMap[ob.key]
            const nb = newMap[ob.key]
            for (const f of ob.fields) {
              f.changed = nb ? (norm(nb.fieldsMap[f.k]) !== norm(f.v)) : false
            }
          }
          log._oldBlocks = oldBlocks
          log._newBlocks = newBlocks
        }
        this.$set(this.detailLogsMap, orderId, details)
      }).catch(() => {})
    },
    // 解析明细块字符串：返回 [{ title, key, fields, fieldsMap }]；key 去掉序号前缀作为稳定匹配键
    parseDetailBlocksRaw(text) {
      if (!text) return []
      const blocks = []
      for (const raw of String(text).split(/\n\s*\n/)) {
        const seg = raw.trim()
        if (!seg) continue
        const lines = seg.split('\n')
        const title = (lines[0] || '').trim()
        const key = title.replace(/^【[^】]*】/, '').trim()
        const fields = []
        const fieldsMap = {}
        const fieldLine = (lines[1] || '').trim()
        if (fieldLine) {
          for (const part of fieldLine.split(/\s{2,}/)) {
            const p = part.trim()
            if (!p) continue
            const sp = p.indexOf(' ')
            const k = sp > 0 ? p.slice(0, sp) : p
            const v = sp > 0 ? p.slice(sp + 1).trim() : ''
            fields.push({ k, v })
            fieldsMap[k] = v
          }
        }
        // 作废状态：后端写入"作废状态 已作废/正常"，用于明细变更记录里高亮已作废明细
        const voided = fieldsMap['作废状态'] === '已作废'
        blocks.push({ title, key, fields, fieldsMap, voided })
      }
      return blocks
    },
    // 模板用：直接返回带标记的结构
    parseDetailBlocks(text) {
      return this.parseDetailBlocksRaw(text)
    },
    full(u) {
      if (!u) return ''
      if (/^(https?:|data:)/i.test(u)) return u
      return (axios.defaults.baseURL || '').replace(/\/api\/?$/, '') + u
    },
    fileShort(u) {
      const p = String(u || '').split('/')
      return p[p.length - 1] || u
    },
    splitUrls(s) {
      return String(s || '').split(',').map(x => x.trim()).filter(Boolean)
    },
    isImage(u) {
      return /\.(png|jpe?g|gif|bmp|webp|svg)(\?|#|$)/i.test(String(u || ''))
    },
    emptyDetail() {
      return {
        productId: null, productName: '', spec: '',
        price: undefined, quantity: undefined, giftQuantity: 0,
        subsidyAmount: 0, actualAmount: undefined, debt: 0, stockLimit: undefined,
        agreementRemaining: undefined, remainingPickup: null, shouldRemaining: undefined, actualRemaining: 0,
        actualUpdateTime: '',
        _autoStockLimit: true, _autoShould: true,
        stockQuantity: 0, _stockManual: false,
        newoutTakenQuantity: 0, newoutTakenAmount: 0, pickupDate: '',
        remark: '', voided: 0
      }
    },
    // 尊贵卡A/C 明细行：是否变更作废 → 整行禁改（开关本身除外，可逆）
    rowDisabled(d) { return Number(d && d.voided) === 1 },
    // 「是否变更」防误触：受控写法——确认后才真正改 d.voided；取消则开关回弹（:value 仍绑旧值）
    onVoidToggle(d, val) {
      const toVoid = Number(val) === 1
      const msg = toVoid
        ? '确定将本条明细「变更作废」吗？<br/>作废后该产品在提货处不可见、不可提货（已有历史记录保留），其它明细不受影响。'
        : '确定取消本条明细的「变更作废」吗？取消后该产品可正常提货。'
      this.$confirm(msg, '请确认', {
        dangerouslyUseHTMLString: true,
        type: 'warning',
        confirmButtonText: toVoid ? '确定作废' : '确定取消作废',
        cancelButtonText: '取消'
      }).then(() => {
        this.$set(d, 'voided', val)
      }).catch(() => {
        this.$forceUpdate()   // 取消：强制重渲染，开关回弹到原值
      })
    },
    /**
     * 已提（含新出库），表单口径：
     * - takenQuantity 加载时已含 inProgress；
     * - 普通卡 / 送存货导入卡：新出库已提是独立的一笔，要叠加（送存货导入时初始化已提已扣过新出库，故 takenQuantity 不含它）；
     * - 尊贵卡A/C 导入卡：初始化已提 = 领取上限 − 剩余可领取，导入时**没扣**新出库 → 已含新出库，不能再叠加，否则重复算。
     */
    acTaken(d) {
      const base = Number(d.takenQuantity) || 0
      const isLegacyAC = ['尊贵卡A', '尊贵卡C'].includes(this.form.category)
        && String(this.form.remark || '').indexOf('历史导入') === 0
      return isLegacyAC ? base : base + (Number(d.newoutTakenQuantity) || 0)
    },
    // 产品名称禁改：A/C 在 作废 或 已提>0 时锁产品名；其它类型不锁
    nameDisabled(d) {
      if (!['尊贵卡A', '尊贵卡C'].includes(this.form.category)) return false
      return Number(d.voided) === 1 || this.acTaken(d) > 0
    },
    /** 存货数量公式：数量 + 赠送数量（不再减去新出库已提数量） */
    computedStock(d) {
      const v = (Number(d.quantity) || 0) + (Number(d.giftQuantity) || 0)
      return v > 0 ? v : 0
    },
    loadList() {
      const params = { type: 'normal' }
      // 嵌入模式：锁定该客户（customerId 精确过滤），仍可叠加产品/状态搜索
      if (this.embedded) params.customerId = this.embeddedCustomer.id
      if (!this.embedded && this.searchForm.customerName) params.customerName = this.searchForm.customerName
      if (this.searchForm.productName) params.productName = this.searchForm.productName
      if (this.searchForm.category) params.category = this.searchForm.category
      if (this.searchForm.stockType) params.stockType = this.searchForm.stockType
      if (this.searchForm.dormantStatus !== '' && this.searchForm.dormantStatus !== null) params.dormantStatus = this.searchForm.dormantStatus
      if (Array.isArray(this.searchForm.saleDateRange) && this.searchForm.saleDateRange.length === 2) {
        params.saleStartDate = this.searchForm.saleDateRange[0]
        params.saleEndDate = this.searchForm.saleDateRange[1]
      }
      // 订单维度（每个订单一行，明细在展开行）
      axios.get('/order/page', { params: { page: this.currentPage, size: this.pageSize, ...params } }).then(res => {
        this.orderList = (res.data && res.data.records) || []
        this.total = (res.data && res.data.total) || 0
        // 嵌入模式每行默认收起；展开后由 onExpandChange 懒加载变更/附件记录
      })
      if (this.embedded) this.loadCustomerTotals()
    },
    // 嵌入模式：拉当前客户全部销售订单(type=normal)，前端汇总明细总金额 + 欠款
    loadCustomerTotals() {
      if (!this.embedded || !this.embeddedCustomer || !this.embeddedCustomer.id) {
        this.customerTotalAmount = 0; this.customerTotalDebt = 0; return
      }
      axios.get('/order/page', {
        params: { page: 1, size: 500, type: 'normal', customerId: this.embeddedCustomer.id }
      }).then(res => {
        const list = (res.data && res.data.records) || []
        let totalAmount = 0, totalDebt = 0
        list.forEach(o => {
          totalAmount += Number(this.rowTotal(o)) || 0
          totalDebt += Number(o.debt) || 0
        })
        this.customerTotalAmount = totalAmount
        this.customerTotalDebt = totalDebt
      }).catch(() => {})
    },
    handleSearch() { this.currentPage = 1; this.loadList() },
    resetSearch() { this.searchForm = { customerName: '', productName: '', category: '', stockType: '', dormantStatus: '', saleDateRange: null }; this.handleSearch() },
    // 表格序号：倒序编号 —— 最新的（列表最上面）= 最大序号 N，最旧的 = 1
    indexMethod(index) {
      return this.total - ((this.currentPage - 1) * this.pageSize + index)
    },
    orderProductNames(row) {
      if (!row || !Array.isArray(row.details) || !row.details.length) return '-'
      const names = []
      for (const d of row.details) {
        if (d && Number(d.voided) === 1) continue   // 已变更作废明细不计入产品名称
        const n = d && d.productName ? this.vipName(d.productName, row.category) : ''
        if (n && names.indexOf(n) < 0) names.push(n)
      }
      return names.length ? names.join('、') : '-'
    },

    openDialog(row) {
      if (row && row.id) {
        // 编辑：拉详情
        axios.get('/order/' + row.id).then(res => {
          const o = res.data || {}
          this.fetchOrderAppsForLimit(o.id)
          this.form = {
            id: o.id,
            customerId: o.customerId,
            customerName: o.customerName || (row && row.customerName) || '',
            customerGender: o.customerGender || '',
            customerPhone: o.customerPhone || '',
            customerAddress: o.customerAddress || '',
            saleDate: o.saleDate || (o.createTime ? String(o.createTime).slice(0, 10) : ''),
            modifyDate: '',
            customerIdCard: o.customerIdCard || '',
            customerAge: o.customerAge != null ? o.customerAge : undefined,
            status: o.status === 3 ? 3 : 0,
            type: o.type || 'normal',
            category: o.category || '',
            stockType: o.stockType || (o.category === '送存货' ? '普通存货' : ''),
            applicableTypeId: o.applicableTypeId != null ? o.applicableTypeId : null,
            applicableTypeName: o.applicableTypeName || '',
            freeServicePeriod: o.freeServicePeriod || '',
            freeServiceMonths: o.freeServiceMonths != null ? Number(o.freeServiceMonths) : (['尊贵卡B','尊贵卡C'].includes(o.category) ? 24 : 0),
            serviceFeeStartDate: o.serviceFeeStartDate ? String(o.serviceFeeStartDate).slice(0, 10) : '',
            serviceFeeEndDate: o.serviceFeeEndDate ? String(o.serviceFeeEndDate).slice(0, 10) : '',
            serviceFeePaidYears: o.serviceFeePaidYears
              ? String(o.serviceFeePaidYears).split(',').map(s => s.trim()).filter(Boolean).map(Number)
              : [],
            serviceFeeSettledYears: o.serviceFeeSettledYears
              ? String(o.serviceFeeSettledYears).split(',').map(s => s.trim()).filter(Boolean).map(Number)
              : [],
            expiryWarningDays: o.expiryWarningDays != null ? Number(o.expiryWarningDays) : undefined,
            dormantStatus: o.dormantStatus != null ? Number(o.dormantStatus) : 0,
            // 明细之外剩余金额：兼容历史字符串("5000"/"¥5000"/"5000元")解析为数值供 el-input-number 使用
            quotaLimit: (function () {
              if (o.quotaLimit == null || o.quotaLimit === '') return undefined
              const m = String(o.quotaLimit).match(/-?\d+(?:\.\d+)?/)
              return m ? Number(m[0]) : undefined
            })(),
            vipBRemaining: (row && row.vipBRemaining != null) ? row.vipBRemaining
              : (o.vipBRemaining != null ? o.vipBRemaining : null),
            shouldQuotaRemaining: o.shouldQuotaRemaining != null ? Number(o.shouldQuotaRemaining) : undefined,
            actualQuotaRemaining: o.actualQuotaRemaining != null ? Number(o.actualQuotaRemaining) : 0,
            actualUpdateTime: o.actualUpdateTime ? String(o.actualUpdateTime).replace('T', ' ').slice(0, 19) : '',
            serviceFeePaymentList: (function() {
              if (!o.serviceFeePayments) return []
              try { return JSON.parse(o.serviceFeePayments) } catch(e) { return [] }
            })(),
            totalAmount: o.totalAmount != null ? Number(o.totalAmount) : 0,
            newoutTakenAmount: o.newoutTakenAmount != null ? Number(o.newoutTakenAmount) : 0,
            newoutPickupDate: o.newoutPickupDate ? String(o.newoutPickupDate).slice(0, 10) : '',
            // 编辑弹窗显示originalDebt（用户设定的总欠款），提交时字段名仍为debt
            debt: o.originalDebt != null ? Number(o.originalDebt) : (o.debt != null ? Number(o.debt) : 0),
            remark: o.remark || '',
            agreementUrl: o.agreementUrl || '',
            signFile: o.signFile || '',
            details: (o.details || []).map((d, idx) => {
              const rowDetail = (row && Array.isArray(row.details) ? row.details[idx] : null) || {}
              const remPickup = d.remainingPickup != null ? d.remainingPickup : (rowDetail.remainingPickup != null ? rowDetail.remainingPickup : null)
              return {
                productId: d.productId, productName: d.productName, spec: d.spec || '',
                price: d.price || 0, quantity: d.quantity || 0, giftQuantity: d.giftQuantity || 0,
                subsidyAmount: d.subsidyAmount || 0, actualAmount: d.actualAmount || 0,
                debt: d.debt || 0, stockLimit: d.stockLimit || 0,
                agreementRemaining: d.agreementRemaining != null ? Number(d.agreementRemaining) : (d.quantity || 0),
                remainingPickup: remPickup != null ? Number(remPickup) : null,
                shouldRemaining: remPickup != null ? Number(remPickup) : (d.shouldRemaining != null ? Number(d.shouldRemaining) : (d.stockLimit || d.quantity || 0)),
                actualRemaining: d.actualRemaining != null ? Number(d.actualRemaining) : 0,
                actualUpdateTime: d.actualUpdateTime ? String(d.actualUpdateTime).replace('T', ' ').slice(0, 19) : '',
                // 存货数量：后端有就用后端的（视为用户已手填，避免被 recalcRow 自动覆盖）；没有按 数量+赠送 兜底
                stockQuantity: d.stockQuantity != null ? Number(d.stockQuantity)
                  : ((Number(d.quantity) || 0) + (Number(d.giftQuantity) || 0)),
                _stockManual: d.stockQuantity != null,
                // 已提 = 已完结 + 在途（OrderDetail 落库字段，列表接口刷新时更新）
                takenQuantity: (Number(d.takenQuantity) || 0) + (Number(d.inProgressQuantity) || 0),
                newoutTakenQuantity: d.newoutTakenQuantity != null ? Number(d.newoutTakenQuantity) : 0,
                newoutTakenAmount: d.newoutTakenAmount != null ? Number(d.newoutTakenAmount) : 0,
                pickupDate: d.pickupDate ? String(d.pickupDate).slice(0, 10) : '',
                remark: d.remark || '',
                voided: Number(d.voided) || 0
              }
            })
          }
          if (this.form.details.length === 0) this.form.details.push(this.emptyDetail())
          this.originActualQuotaRemaining = this.form.actualQuotaRemaining != null ? Number(this.form.actualQuotaRemaining) : 0
          this.originActualRemainingList = (this.form.details || []).map(d => Number(d.actualRemaining || 0))
          this.originActualUpdateTime = this.form.actualUpdateTime ? String(this.form.actualUpdateTime).replace('T', ' ').slice(0, 16) : ''
          this.originDetailActualUpdateTimeList = (this.form.details || []).map(d => d.actualUpdateTime ? String(d.actualUpdateTime).replace('T', ' ').slice(0, 16) : '')

          // 如果订单有欠款，加载还款计划（包括已完成和未完成）
          if (Number(o.debt || 0) > 0 && this.form.category !== '尊贵卡A') {
            console.log('🔍 开始加载还款计划，订单ID:', o.id, '欠款:', o.debt)

            axios.get('/order/payment-plan/all/' + o.id).then(planRes => {
              console.log('✅ API 响应:', planRes.data)
              const plans = planRes.data.data || []
              console.log('📋 还款计划数量:', plans.length, '数据:', plans)

              // 如果有保存的还款计划，使用保存的数据
              if (plans.length > 0) {
                this.form.paymentPlans = plans.map(p => ({
                  id: p.id,
                  period: p.period,
                  expectedDate: p.expectedDate ? String(p.expectedDate).slice(0, 10) : '',
                  expectedAmount: Number(p.expectedAmount) || 0,
                  paidAmount: Number(p.paidAmount) || 0,
                  status: p.status || 0,
                  overdueFlag: p.overdueFlag || 0,
                  firstPaymentDate: p.firstPaymentDate || null
                }))
                console.log('✅ 加载了保存的还款计划:', this.form.paymentPlans.length, '期')
              } else {
                // 如果没有还款计划数据，初始化默认计划（使用originalDebt）
                this.form.paymentPlans = [{
                  expectedDate: '',
                  expectedAmount: Number(o.originalDebt || o.debt || 0)
                }]
                console.log('⚠️ 没有还款计划数据，使用默认计划')
              }

              // 等还款计划加载完成后再打开弹窗
              this.dialogVisible = true
              console.log('✅ 弹窗已打开，还款计划期数:', this.form.paymentPlans.length)
            }).catch(err => {
              console.error('❌ 加载还款计划失败:', err)
              // 如果加载失败，初始化默认计划（使用originalDebt）
              this.form.paymentPlans = [{
                expectedDate: '',
                expectedAmount: Number(o.originalDebt || o.debt || 0)
              }]
              console.log('⚠️ 加载失败，使用默认计划')
              // 即使失败也要打开弹窗
              this.dialogVisible = true
            })
          } else {
            // 没有欠款或者是尊贵卡A，清空还款计划
            this.form.paymentPlans = []
            this.dialogVisible = true
          }
        })
      } else {
        this.form = this.emptyForm()
        this.form._customerStock = 0
        // 嵌入模式：新建订单锁定为当前客户，带出其基础信息
        if (this.embedded) {
          const c = this.embeddedCustomer || {}
          this.form.customerId = c.id
          this.form.customerName = c.name || ''
          this.form.customerGender = c.gender || ''
          this.form.customerAge = c.age != null ? c.age : undefined
          this.form.customerPhone = c.contactPhone || c.telephone || c.phone || ''
          this.form.customerAddress = c.address || ''
          this.form.customerIdCard = c.idCard || ''
        }
        this.dialogVisible = true
      }
    },
    // 仅用于前端展示：尊贵卡类订单的产品名加"尊贵卡-"前缀；先查 startsWith 避免重叠
    vipName(name, category) {
      if (!name) return name
      if (!(category && String(category).startsWith('尊贵卡'))) return name
      return String(name).startsWith('尊贵卡-') ? name : ('尊贵卡-' + name)
    },
    addServiceFeePayment() {
      if (!Array.isArray(this.form.serviceFeePaymentList)) {
        this.$set(this.form, 'serviceFeePaymentList', [])
      }
      this.form.serviceFeePaymentList.push({
        payDate: new Date().toISOString().slice(0, 10),
        amount: 0,
        remark: ''
      })
    },
    addDetail() { this.form.details.push(this.emptyDetail()) },
    // 删除明细按钮：送存货且已提货且未提完时禁用
    detailDeleteDisabled(d) {
      if (!['送存货', '尊贵卡A', '尊贵卡C'].includes(this.form.category)) return false
      return Number(d.takenQuantity || 0) > 0
    },
    detailDeleteReason(d) {
      const isVipAC = this.form.category === '尊贵卡A' || this.form.category === '尊贵卡C'
      return `已提 ${Number(d.takenQuantity || 0)}${isVipAC ? '（本年度）' : ''}，已有出库记录，不能删除`
    },
    onProductChange(row) {
      const p = this.productOpts.find(x => x.id === row.productId)
      if (p) {
        row.productName = p.name
        row.spec = p.spec || row.spec
        row.price = Number(p.price) || 0
      }
      this.recalcRow(row)
    },
    isYearPaid(year) {
      if (!Array.isArray(this.form.serviceFeePaidYears)) return false
      return this.form.serviceFeePaidYears.map(Number).includes(Number(year))
    },
    isYearSettled(year) {
      if (!Array.isArray(this.form.serviceFeeSettledYears)) return false
      return this.form.serviceFeeSettledYears.map(Number).includes(Number(year))
    },
    handleYearSettledChange(yearVal, settled) {
      const y = Number(yearVal)
      const actionText = settled ? '已结清' : '未结清'
      const confirmText = settled ? '确定结清' : '确定修改'
      const cancelText = settled ? '暂不结清' : '暂不修改'

      this.$confirm(`确定要将【${y}年度】服务费状态修改为【${actionText}】吗？`, '提示', {
        confirmButtonText: confirmText,
        cancelButtonText: cancelText,
        type: 'warning'
      }).then(() => {
        if (!Array.isArray(this.form.serviceFeeSettledYears)) {
          this.$set(this.form, 'serviceFeeSettledYears', [])
        }
        const idx = this.form.serviceFeeSettledYears.map(Number).indexOf(y)
        if (settled) {
          if (idx === -1) this.form.serviceFeeSettledYears.push(y)
        } else {
          if (idx > -1) this.form.serviceFeeSettledYears.splice(idx, 1)
        }
        this.$message.success(`【${y}年度】服务费结清状态已修改为【${actionText}】`)
      }).catch(() => {
        // 用户取消，状态保持不变
      })
    },
    handleYearCheckboxChange(yearVal, checked) {
      const y = Number(yearVal)
      if (!Array.isArray(this.form.serviceFeePaidYears)) {
        this.$set(this.form, 'serviceFeePaidYears', [])
      }
      if (checked) {
        if (!this.isYearPaid(y)) {
          this.form.serviceFeePaidYears.push(y)
        }
        // 勾选后自动展开明细面板
        if (!this.isYearExpanded(y)) {
          this.toggleYearExpand(y)
        }
        this.syncDormantFromPaid()
      } else {
        // 取消勾选：弹出确认框
        this.$confirm(`确定要取消勾选【${y}年度】服务费已缴纳状态吗？`, '提示', {
          confirmButtonText: '确定取消',
          cancelButtonText: '暂不取消',
          type: 'warning'
        }).then(() => {
          const idx = this.form.serviceFeePaidYears.map(Number).indexOf(y)
          if (idx > -1) {
            this.form.serviceFeePaidYears.splice(idx, 1)
          }
          if (Array.isArray(this.form.serviceFeeSettledYears)) {
            const sIdx = this.form.serviceFeeSettledYears.map(Number).indexOf(y)
            if (sIdx > -1) this.form.serviceFeeSettledYears.splice(sIdx, 1)
          }
          this.syncDormantFromPaid()
        }).catch(() => {
          // 用户放弃取消
        })
      }
    },
    isPastYear(year) {
      if (!year) return false
      const cur = this.currentServiceYear() || new Date().getFullYear()
      return Number(year) < cur
    },
    isYearExpanded(year) {
      return (this.expandedServiceFeeYears || []).includes(Number(year))
    },
    toggleYearExpand(year) {
      const y = Number(year)
      if (!Array.isArray(this.expandedServiceFeeYears)) {
        this.$set(this, 'expandedServiceFeeYears', [])
      }
      const idx = this.expandedServiceFeeYears.indexOf(y)
      if (idx > -1) {
        this.expandedServiceFeeYears.splice(idx, 1)
      } else {
        this.expandedServiceFeeYears.push(y)
      }
    },
    getYearPayments(year) {
      if (!Array.isArray(this.form.serviceFeePaymentList)) return []
      return this.form.serviceFeePaymentList.filter(p => Number(p.year) === Number(year))
    },
    getYearPaymentsTotal(year) {
      return this.getYearPayments(year).reduce((sum, item) => sum + (Number(item.amount) || 0), 0)
    },
    getYearPaymentsCount(year) {
      return this.getYearPayments(year).length
    },
    addYearPayment(year) {
      if (!Array.isArray(this.form.serviceFeePaymentList)) {
        this.$set(this.form, 'serviceFeePaymentList', [])
      }
      this.form.serviceFeePaymentList.push({
        year: Number(year),
        payDate: new Date().toISOString().slice(0, 10),
        amount: 0,
        remark: ''
      })
    },
    removeYearPayment(year, idx) {
      if (!Array.isArray(this.form.serviceFeePaymentList)) return
      const yearItems = this.getYearPayments(year)
      const targetItem = yearItems[idx]
      if (targetItem) {
        const realIdx = this.form.serviceFeePaymentList.indexOf(targetItem)
        if (realIdx > -1) {
          this.form.serviceFeePaymentList.splice(realIdx, 1)
        }
      }
    },
    computeShouldQuotaRemaining() {
      if (this.form.category !== '尊贵卡B') return 0
      const base = Number(this.form.totalAmount) || 0
      const legacy = String(this.form.remark || '').indexOf('历史导入') === 0
      const legacyTaken = (legacy && this.form.legacyTakenAmount != null) ? (Number(this.form.legacyTakenAmount) || 0) : 0

      // 判断新出库已提提货日期是否在当年窗口
      const inWin = this.isNewoutPickupInWindow('B')
      const newoutAmt = (!legacy && inWin) ? (Number(this.form.newoutTakenAmount) || 0) : 0

      // 线上已提折算金额（从 server 返回的 vipBRemaining 反推）
      let onlineTaken = this.form._cachedOnlineTaken
      if (onlineTaken === undefined) {
        if (this.form.vipBRemaining != null) {
          const origInWin = this.isNewoutPickupInWindow('B')
          const origNewout = (!legacy && origInWin) ? (Number(this.form.newoutTakenAmount) || 0) : 0
          onlineTaken = Math.max(0, base - Number(this.form.vipBRemaining) - origNewout - legacyTaken)
        } else {
          onlineTaken = 0
        }
        this.$set(this.form, '_cachedOnlineTaken', onlineTaken)
      }

      const rem = base - onlineTaken - newoutAmt - legacyTaken
      return rem < 0 ? 0 : Math.round(rem * 100) / 100
    },
    computeShouldRemaining(d) {
      if (!d) return 0
      if (d.shouldRemaining != null) return d.shouldRemaining
      if (d.remainingPickup != null) return d.remainingPickup
      return d.stockLimit != null ? Number(d.stockLimit) : (Number(d.quantity) || 0)
    },
    onStockLimitChange(row) {
      row._autoStockLimit = false
      this.recalcRow(row)
    },
    recalcRow(row) {
      // 送存货：补贴 = 单价 × 数量 − 实付；尊贵卡A/B/C：补贴 = 单价 × 领取上限 − 实付
      // 数量与领取上限都绑定在 d.quantity 上，故基数取 row.quantity 即可
      const total = (Number(row.quantity) || 0) * (Number(row.price) || 0)
      const actual = Number(row.actualAmount)
      if (row.actualAmount === undefined || row.actualAmount === null || row.actualAmount === '' || isNaN(actual)) {
        this.$set(row, 'subsidyAmount', 0)
      } else {
        // 补贴不能为负数：实付高于应收时补贴记 0
        this.$set(row, 'subsidyAmount', Math.max(0, +(total - actual).toFixed(2)))
      }
      // 1. 协议剩余 严格等于 数量（响应式实时同步）
      if (['尊贵卡B', '尊贵卡C'].includes(this.form.category)) {
        this.$set(row, 'agreementRemaining', row.quantity != null ? row.quantity : 0)
      }
      // 2. 领取上限 默认等于 数量；应该剩余 与 领取上限/已提/本年度新出库 动态实时计算 (this.$set 触发 UI 即时渲染)
      if (['尊贵卡A', '尊贵卡C'].includes(this.form.category)) {
        if (row.stockLimit == null || row.stockLimit === '' || row._autoStockLimit) {
          this.$set(row, 'stockLimit', row.quantity != null ? row.quantity : 0)
          row._autoStockLimit = true
        }
        const newLimit = Number(row.stockLimit) || 0
        const taken = Number(row.takenQuantity) || 0
        // 仅当提货日期在当前服务年度窗口内时，才扣除新出库已提数量
        const inWindow = this.isNewoutPickupInWindow('C', row)
        const newout = inWindow ? (Number(row.newoutTakenQuantity) || 0) : 0

        const calcShould = Math.max(0, newLimit - taken - newout)
        this.$set(row, 'shouldRemaining', calcShould)
        this.$set(row, 'remainingPickup', calcShould)
      }
      // 送存货：用户未手动改过存货数量时，自动跟着 数量+赠送 同步
      if (this.form && this.form.category === '送存货' && !row._stockManual) {
        this.$set(row, 'stockQuantity', (Number(row.quantity) || 0) + (Number(row.giftQuantity) || 0))
      }
    },
    onActualQuotaRemainingChange(val) {
      if (val == null || val === '') return
      const should = this.computeShouldQuotaRemaining()
      if (Number(val) > should) {
        this.$message.warning(`实际剩余额度（¥${val}）不能大于现在的应该剩余额度（¥${should}）`)
        this.$nextTick(() => {
          this.form.actualQuotaRemaining = should
        })
      }
    },
    onActualRemainingChange(d, val) {
      if (val == null || val === '') return
      const should = this.computeShouldRemaining(d)
      if (Number(val) > should) {
        this.$message.warning(`明细【${d.productName || '产品'}】的实际剩余（${val}件）不能大于现在的应该剩余（${should}件）`)
        this.$nextTick(() => {
          d.actualRemaining = should
        })
      }
    },
    handleSubmit() {
      console.log('=== handleSubmit 被调用 ===')
      console.log('form.paymentPlans:', JSON.stringify(this.form.paymentPlans))
      console.log('form.debt:', this.form.debt)
      console.log('form.category:', this.form.category)

      const name = (this.form.customerName || '').trim()
      if (!name) { this.$message.warning('请输入客户姓名'); return }
      // 编辑模式必须填修改/变更时间
      if (this.form.id) {
        if (!this.form.modifyDate) {
          this.$message.warning('请先填写修改/变更时间')
          return
        }
      }
      // 尊贵卡B：实际剩余额度手填校验（不能大于应该剩余额度；仅当实际剩余额度 > 0 且未选择实际剩余时间时才提示）
      if (this.form.category === '尊贵卡B' && this.form.actualQuotaRemaining != null && this.form.actualQuotaRemaining !== '') {
        const shouldB = this.computeShouldQuotaRemaining()
        const actB = Number(this.form.actualQuotaRemaining) || 0
        if (actB > shouldB) {
          this.$message.error(`【尊贵卡B】实际剩余额度（¥${this.form.actualQuotaRemaining}）不能大于当前的应该剩余额度（¥${shouldB}）`)
          return
        }
        if (actB > 0 && (!this.form.actualUpdateTime || String(this.form.actualUpdateTime).length < 16)) {
          this.$message.warning('已填写实际剩余额度，请在「实际剩余时间」中选择精确到【时:分】的时间')
          return
        }
        if (this.form.actualUpdateTime) {
          const curTime = String(this.form.actualUpdateTime).replace('T', ' ').slice(0, 16)
          if (curTime !== this.originActualUpdateTime) {
            const maxStr = this.getLatestAppTimeForOrder(this.form.id)
            if (maxStr && curTime <= maxStr) {
              this.$message.error(`【尊贵卡B】实际剩余时间不可早于或等于本年度最新提货时间（${maxStr}），避免重复扣减！请重新选择。`)
              return
            }
          }
        }
      }
      // 尊贵卡C：明细实际剩余手填校验（不能大于应该剩余件数；仅当实际剩余件数 > 0 且未选择实际剩余时间时才提示）
      if (this.form.category === '尊贵卡C') {
        for (let i = 0; i < (this.form.details || []).length; i++) {
          const d = this.form.details[i]
          if (d.actualRemaining != null && d.actualRemaining !== '') {
            const shouldC = this.computeShouldRemaining(d)
            const actC = Number(d.actualRemaining) || 0
            if (actC > shouldC) {
              this.$message.error(`明细 ${i + 1}（${d.productName || '产品'}）实际剩余（${d.actualRemaining}件）不能大于当前的应该剩余（${shouldC}件）`)
              return
            }
            if (actC > 0 && (!d.actualUpdateTime || String(d.actualUpdateTime).length < 16)) {
              this.$message.warning(`明细 ${i + 1} 已填写实际剩余，请在「实际剩余时间」中选择精确到【时:分】的时间`)
              return
            }
            if (d.actualUpdateTime) {
              const curTime = String(d.actualUpdateTime).replace('T', ' ').slice(0, 16)
              const origTime = this.originDetailActualUpdateTimeList ? (this.originDetailActualUpdateTimeList[i] || '') : ''
              if (curTime !== origTime) {
                const maxStr = this.getLatestAppTimeForProduct(this.form.id, d.productId)
                if (maxStr && curTime <= maxStr) {
                  this.$message.error(`明细 ${i + 1}（${d.productName || '产品'}）实际剩余时间不可早于或等于本年度最新提货时间（${maxStr}），避免重复扣减！请重新选择。`)
                  return
                }
              }
            }
          }
        }
      }
      if (!this.form.category) { this.$message.warning('请选择类型'); return }
      // 送存货：存货类型必选；如果是品鉴存货/试用存货，试用类型必选
      if (this.form.category === '送存货') {
        if (!this.form.stockType) {
          this.$message.warning('请选择存货类型')
          return
        }
        if ((this.form.stockType === '品鉴存货' || this.form.stockType === '试用存货') && !this.form.applicableTypeId) {
          this.$message.warning('请选择试用类型')
          return
        }
      }
      // 尊贵卡A/B/C 合同服务起始日必填（提货起始日闸据此判定）
      if (['尊贵卡A', '尊贵卡B', '尊贵卡C'].includes(this.form.category) && !this.form.serviceFeeStartDate) {
        this.$message.warning('请选择合同服务起始日'); return
      }
      // 尊贵卡B 基础额度必填
      if (this.form.category === '尊贵卡B' && (!this.form.totalAmount || Number(this.form.totalAmount) <= 0)) {
        this.$message.warning('请填写尊贵卡B的额度（必须大于 0）'); return
      }
      // 有欠款时，还款计划必填（送存货/尊贵卡类型）
      if (['送存货', '尊贵卡B', '尊贵卡C'].includes(this.form.category) && Number(this.form.debt || 0) > 0) {
        if (!this.form.paymentPlans || this.form.paymentPlans.length === 0) {
          this.$message.warning('订单有欠款时，必须设置还款计划')
          return
        }
        // 校验每期还款计划
        for (let i = 0; i < this.form.paymentPlans.length; i++) {
          const plan = this.form.paymentPlans[i]
          if (!plan.expectedDate) {
            this.$message.warning(`第${i + 1}期还款计划的约定日期不能为空`)
            return
          }
          if (!plan.expectedAmount || plan.expectedAmount <= 0) {
            this.$message.warning(`第${i + 1}期还款计划的约定金额必须大于0`)
            return
          }
        }
        // 校验总计是否等于欠款
        const total = this.totalPaymentPlans
        const debt = Number(this.form.debt || 0)
        if (Math.abs(total - debt) > 0.01) {
          this.$message.warning(`还款计划总计（¥${total.toFixed(2)}）必须等于订单欠款（¥${debt.toFixed(2)}）`)
          return
        }
      }
      // 尊贵卡B 不再有明细产品概念：所有提货按 单价×数量 扣剩余金额，不校验也不收集明细
      if (this.form.category !== '尊贵卡B') {
        if (!this.form.details.length) {
          this.$message.warning('请添加订单明细'); return
        }
        const isBlank = v => v === null || v === undefined || v === ''
        const isDeliver = this.form.category === '送存货'
        const isVipCard = ['尊贵卡A', '尊贵卡B', '尊贵卡C'].includes(this.form.category)
        const requiredFields = [
          { key: 'productId', label: '产品名称' },
          { key: 'price', label: '单价' },
          { key: 'quantity', label: isVipCard ? '领取上限' : '数量' },
          { key: 'actualAmount', label: '实付' }
        ]
        // 禁售上限已挪到商品管理维护，销售订单明细不再需要该字段
        for (let i = 0; i < this.form.details.length; i++) {
          const d = this.form.details[i]
          for (const f of requiredFields) {
            const v = d[f.key]
            if (isBlank(v) || (typeof v === 'string' && !v.trim())) {
              this.$message.warning(`销售订单 ${i + 1} 的「${f.label}」不能为空`)
              return
            }
          }
          // 尊贵卡A/C：领取上限 不能大于 数量
          if (['尊贵卡A', '尊贵卡C'].includes(this.form.category)) {
            const sl = Number(d.stockLimit) || 0
            const qty = Number(d.quantity) || 0
            if (sl > qty) {
              this.$message.warning(`销售订单 ${i + 1} 领取上限(${sl}) 不能大于数量(${qty})`)
              return
            }
          }
          // 送存货：存货数量 不能小于已提（累计，含新出库；送存货不按年重置，故是累计已提非本年度）
          if (this.form.category === '送存货') {
            const sq = (d.stockQuantity != null && d.stockQuantity !== '')
              ? (Number(d.stockQuantity) || 0)
              : ((Number(d.quantity) || 0) + (Number(d.giftQuantity) || 0))
            const taken = this.acTaken(d)
            if (taken > sq) {
              this.$message.warning(`明细 ${i + 1}「${d.productName || ''}」已提 ${taken}（含新出库），存货数量 ${sq} 不能小于已提`)
              return
            }
            // 新出库已提数量 > 0 时，新出库提货日期必填
            const newoutTaken = Number(d.newoutTakenQuantity) || 0
            if (newoutTaken > 0 && !d.pickupDate) {
              this.$message.warning(`明细 ${i + 1}「${d.productName || ''}」新出库已提数量 > 0 时，新出库提货日期必填`)
              return
            }
          }
          // 尊贵卡A/C：领取上限 不能小于本年度已提（含新出库已提；导入卡 acTaken 已避免重复算）
          if (['尊贵卡A', '尊贵卡C'].includes(this.form.category)) {
            const taken = this.acTaken(d)
            const sl = Number(d.stockLimit) || 0
            if (taken > sl) {
              this.$message.warning(`明细 ${i + 1}「${d.productName || ''}」本年度已提 ${taken}（含新出库），领取上限 ${sl} 不能小于已提`)
              return
            }
            // 新出库已提数量 > 0 时提货日期必填（数量上限已由上面"已提含新出库 ≤ 领取上限"覆盖）
            const acNewout = Number(d.newoutTakenQuantity) || 0
            if (acNewout > 0 && !d.pickupDate) {
              this.$message.warning(`明细 ${i + 1}「${d.productName || ''}」新出库已提数量 > 0 时，新出库提货日期必填`)
              return
            }
          }
        }
      }
      // 尊贵卡B 卡级：新出库已提额度 不能大于额度；> 0 时提货日期必填
      if (this.form.category === '尊贵卡B') {
        const bNewout = Number(this.form.newoutTakenAmount) || 0
        const base = Number(this.form.totalAmount) || 0
        if (base > 0 && bNewout > base) {
          this.$message.warning(`新出库已提额度 ${bNewout} 不能大于 额度 ${base}`)
          return
        }
        if (bNewout > 0 && !this.form.newoutPickupDate) {
          this.$message.warning('新出库已提额度 > 0 时，新出库提货日期必填')
          return
        }
      }
      // 合同实付金额已废弃；totalAmount 改作"明细总金额" = Σ d.actualAmount
      // 送存货按款锁提需要它作为已付金额的基数：已付 = totalAmount - debt
      // 尊贵卡B 例外：totalAmount 存"额度"(基础额度)，与 quotaLimit(剩余额度) 两值独立，原样保存
      const totalAmount = this.form.category === '尊贵卡B'
        ? (Number(this.form.totalAmount) || 0)
        : (this.form.details || []).reduce((s, d) => s + (Number(d.actualAmount) || 0), 0)
      // 存货数量：优先用 d.stockQuantity（用户可能手动改过）；为空才按 数量+赠送 兜底
      const details = this.form.details.map(d => {
        let sq
        if (d.stockQuantity != null && d.stockQuantity !== '') {
          sq = Math.max(0, Number(d.stockQuantity) || 0)
        } else {
          sq = Math.max(0, (Number(d.quantity) || 0) + (Number(d.giftQuantity) || 0))
        }
        return { ...d, stockQuantity: sq }
      })
      // freeServicePeriod 字段已废弃（旧逻辑用作"已缴年份总天数"，无业务意义）；
      // 「免服务费剩余天数」展示改为前端派生 = max(0, 服务费起始日 - today)，不再落库。
      const serviceFeePaidYears = (this.form.serviceFeePaidYears || []).join(',')
      const serviceFeeSettledYears = (this.form.serviceFeeSettledYears || []).join(',')
      const serviceFeePayments = JSON.stringify(this.form.serviceFeePaymentList || [])
      // 尊贵卡B 明细之外剩余金额：用户手填的基础额度，后端按提货动态扣减
      let quotaLimit = this.form.quotaLimit != null && this.form.quotaLimit !== ''
        ? String(this.form.quotaLimit)
        : ''
      // 尊贵卡B 新建时若未填剩余额度，默认 = 额度(满额可用)
      if (this.form.category === '尊贵卡B' && quotaLimit === '' && this.form.totalAmount != null && this.form.totalAmount !== '') {
        quotaLimit = String(this.form.totalAmount)
      }
      const body = { ...this.form, customerName: name, totalAmount, details, serviceFeePaidYears, serviceFeeSettledYears, serviceFeePayments, quotaLimit }
      delete body.freeServicePeriod
      const req = this.form.id ? axios.put('/order', body) : axios.post('/order', body)
      req.then(res => {
        const data = res.data
        const ok = data === true || (data && data.success !== false)
        if (ok) {
          this.$message.success(this.form.id ? '更新成功' : '新建成功')
          const editedId = this.form.id
          this.dialogVisible = false
          this.loadList()
          // 修改成功后立刻刷新该行的变更记录（如果当前展开了）
          if (editedId) {
            this.loadChangeLog(editedId)
            this.loadAttachLog(editedId)
            this.loadPaymentPlans(editedId)
          }
        } else {
          this.$message.error((data && data.message) || '操作失败')
        }
      }).catch(err => {
        const msg = err && err.response && err.response.data && err.response.data.message
        if (msg) this.$message.error(msg)
      })
    },
    computeServiceTerm(row) {
      if (!row) return ''
      const start = String(row.serviceFeeStartDate || '').slice(0, 10)
      if (!start) return ''
      const end = row.serviceFeeEndDate
        ? String(row.serviceFeeEndDate).slice(0, 10)
        : this.deriveServiceEndDate(row.serviceFeeStartDate, row.freeServicePeriod)
      if (!end) return ''
      return start + ' 至 ' + end
    },
    formatDateMinute(v) {
      if (!v) return ''
      const s = String(v).replace('T', ' ')
      return s.length >= 16 ? s.slice(0, 16) : s
    },
    deriveServiceEndDate(startDate, period) {
      const start = String(startDate || '').slice(0, 10)
      const p = (period || '').trim()
      if (!start || !p) return ''
      const m = p.match(/^(\d+)\s*(年|个月|月|天|日)$/)
      if (!m) return ''
      const n = Number(m[1])
      const u = m[2]
      const d = new Date(start.replace(/-/g, '/'))
      if (isNaN(d.getTime())) return ''
      if (u === '年') d.setMonth(d.getMonth() + n * 12)
      else if (u === '个月' || u === '月') d.setMonth(d.getMonth() + n)
      else d.setDate(d.getDate() + n)
      const yyyy = d.getFullYear()
      const mm = String(d.getMonth() + 1).padStart(2, '0')
      const dd = String(d.getDate()).padStart(2, '0')
      return `${yyyy}-${mm}-${dd}`
    },
    // 免服务费剩余天数 = max(0, 服务费起始日 - today)；超过免期显示 "0 天（已开始计费）"
    computeFreeServiceDaysLeft(row) {
      if (!row) return '-'
      const feeStartStr = this.computeServiceFeeStart(row.serviceFeeStartDate, row.freeServiceMonths)
      if (!feeStartStr) return '-'
      const parts = feeStartStr.split('-').map(Number)
      const feeStart = new Date(parts[0], parts[1] - 1, parts[2])
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const diff = Math.ceil((feeStart - today) / 86400000)
      if (diff <= 0) return '0 天（已开始计费）'
      return diff + ' 天'
    },
    // 工具：合同起始日 + 免服务期月数 → 派生服务费起始日（YYYY-MM-DD 字符串，空入参返回 ''）
    computeServiceFeeStart(contractStartDate, freeMonths) {
      const s = String(contractStartDate || '').slice(0, 10)
      if (!s) return ''
      const parts = s.split('-').map(Number)
      if (parts.length < 3 || parts.some(isNaN)) return ''
      const d = new Date(parts[0], parts[1] - 1, parts[2])
      if (isNaN(d.getTime())) return ''
      const m = Number(freeMonths) > 0 ? Number(freeMonths) : 0
      d.setMonth(d.getMonth() + m)
      const yyyy = d.getFullYear()
      const mm = String(d.getMonth() + 1).padStart(2, '0')
      const dd = String(d.getDate()).padStart(2, '0')
      return `${yyyy}-${mm}-${dd}`
    },
    // 服务费到期时间（当前年度应缴日）：feeStart = 合同起始日 + 免期月数；从 feeStart 起按年滚到第一个"未缴"年
    computeServiceFeeDue(row) {
      if (!row || !row.serviceFeeStartDate) return ''
      const feeStartStr = this.computeServiceFeeStart(row.serviceFeeStartDate, row.freeServiceMonths)
      if (!feeStartStr) return ''
      const ps = feeStartStr.split('-').map(Number)
      if (ps.length < 3) return ''
      // 已缴年份：兼容字符串 "2025,2026" / 数组
      let raw = row.serviceFeePaidYears
      let paidArr = []
      if (Array.isArray(raw)) paidArr = raw
      else if (raw) paidArr = String(raw).split(/[,，;；]/)
      const paid = new Set(paidArr.map(x => parseInt(x)).filter(n => !isNaN(n)))
      let y = ps[0]
      for (let i = 0; i < 200; i++) { if (!paid.has(y)) break; y++ }
      const dueDate = new Date(y, ps[1] - 1, ps[2] - 1)
      const mm = String(dueDate.getMonth() + 1).padStart(2, '0')
      const dd = String(dueDate.getDate()).padStart(2, '0')
      return `${dueDate.getFullYear()}-${mm}-${dd}`
    },
    computePaidPeriod() {
      // 已缴服务费总天数：年度槽起点 = 派生服务费起始日，每年取 365 天累加
      const start = this.computeServiceFeeStart(this.form.serviceFeeStartDate, this.form.freeServiceMonths)
      const years = this.form.serviceFeePaidYears || []
      if (!start || !years.length) return '0天'
      const parts = start.split('-').map(Number)
      const m = parts[1]
      const day = parts[2]
      let total = 0
      for (const y of years) {
        const a = new Date(y, m - 1, day)
        const b = new Date(y + 1, m - 1, day)
        total += Math.round((b - a) / 86400000)
      }
      return total + '天'
    },
    // 服务费到期提醒：与后端 scanVipBCServiceFeeDue 同口径。
    // 找下一个未缴年度槽起点 nextDue（=该年度缴费截止日），返回 nextDue - warnDays（已逾期则提示 "已逾期 N 天"）。
    // warnDays 优先级：订单 expiryWarningDays > 全局 30（前端展示不引入客户级，与详情卡同一行简化）
    serviceRemindDate(row) {
      if (!row) return ''
      const start = this.computeServiceFeeStart(row.serviceFeeStartDate, row.freeServiceMonths)
      if (!start) return ''
      const parts = start.split('-').map(Number)
      if (parts.length < 3 || parts.some(isNaN)) return ''
      const paid = new Set(
        String(row.serviceFeePaidYears || '')
          .split(',').map(s => s.trim()).filter(Boolean).map(Number).filter(n => !isNaN(n))
      )
      let cur = new Date(parts[0], parts[1] - 1, parts[2])
      let nextDue = null
      for (let i = 0; i < 200; i++) {
        if (!paid.has(cur.getFullYear())) { nextDue = new Date(cur.getTime()); break }
        cur.setFullYear(cur.getFullYear() + 1)
      }
      if (!nextDue) return ''
      const today = new Date(); today.setHours(0, 0, 0, 0)
      const daysToDue = Math.round((nextDue - today) / 86400000)
      if (daysToDue < 0) return `已逾期 ${-daysToDue} 天`
      const warnDays = Number(row.expiryWarningDays) > 0 ? Number(row.expiryWarningDays) : 30
      const remind = new Date(nextDue.getTime())
      remind.setDate(remind.getDate() - warnDays)
      return this.fmtYMD(remind)
    },
    fmtYMD(d) {
      const yyyy = d.getFullYear()
      const mm = String(d.getMonth() + 1).padStart(2, '0')
      const dd = String(d.getDate()).padStart(2, '0')
      return `${yyyy}-${mm}-${dd}`
    },
    isFutureCard(targetForm) {
      const f = targetForm || this.form
      if (!f || !f.serviceFeeStartDate) return false
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const parts = String(f.serviceFeeStartDate).slice(0, 10).split('-').map(Number)
      if (parts.length < 3 || parts.some(isNaN)) return false
      const winStart = new Date(parts[0], parts[1] - 1, parts[2])
      return today < winStart
    },
    getServiceYearWindowDates(targetForm) {
      const f = targetForm || this.form
      if (!f) return null
      const startStr = f.serviceFeeStartDate || (f.saleDate ? String(f.saleDate).slice(0, 10) : (f.createTime ? String(f.createTime).slice(0, 10) : ''))
      if (!startStr) return null
      const parts = startStr.split('-').map(Number)
      if (parts.length < 3 || parts.some(isNaN)) return null
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      let winStart = new Date(parts[0], parts[1] - 1, parts[2], 0, 0, 0)
      if (today < winStart) {
        let winEnd = new Date(parts[0] + 1, parts[1] - 1, parts[2] - 1, 23, 59, 59)
        return { winStart, winEnd, isFuture: true }
      }
      while (true) {
        let nextStart = new Date(winStart.getFullYear() + 1, winStart.getMonth(), winStart.getDate(), 0, 0, 0)
        if (today >= nextStart) {
          winStart = nextStart
        } else {
          break
        }
      }
      let winEnd = new Date(winStart.getFullYear() + 1, winStart.getMonth(), winStart.getDate() - 1, 23, 59, 59)
      return { winStart, winEnd, isFuture: false }
    },
    getServiceYearWindow(targetForm) {
      const f = targetForm || this.form
      if (!f) return '—'
      const startStr = f.serviceFeeStartDate || (f.saleDate ? String(f.saleDate).slice(0, 10) : (f.createTime ? String(f.createTime).slice(0, 10) : ''))
      if (!startStr) return '未设置起始日期'
      const parts = startStr.split('-').map(Number)
      if (parts.length < 3 || parts.some(isNaN)) return '—'
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      let winStart = new Date(parts[0], parts[1] - 1, parts[2])
      if (today < winStart) {
        let winEnd = new Date(parts[0] + 1, parts[1] - 1, parts[2] - 1)
        return `${this.fmtYMD(winStart)} 至 ${this.fmtYMD(winEnd)}`
      }
      while (true) {
        let nextStart = new Date(winStart.getFullYear() + 1, winStart.getMonth(), winStart.getDate())
        if (today >= nextStart) {
          winStart = nextStart
        } else {
          break
        }
      }
      let winEnd = new Date(winStart.getFullYear() + 1, winStart.getMonth(), winStart.getDate() - 1)
      return `${this.fmtYMD(winStart)} 至 ${this.fmtYMD(winEnd)}`
    },
    productStockOf(d) {
      if (!d || !d.productId) return '-'
      const p = (this.productOpts || []).find(x => x.id === d.productId)
      return p ? (p.stock != null ? p.stock : 0) : '-'
    },
    categoryTag(c) {
      if (c === '送存货') return 'warning'
      if (c === '试用' || c === '产品试用') return 'success'
      if (c === '尊贵卡A') return 'warning' // tag-vip-a 覆盖为金
      if (c === '尊贵卡B') return 'primary'
      if (c === '尊贵卡C') return 'info'    // tag-vip-c 覆盖为紫
      return ''
    },
    categoryClass(c) {
      if (c === '尊贵卡A') return 'tag-vip-a'
      if (c === '尊贵卡B') return 'tag-vip-b'
      if (c === '尊贵卡C') return 'tag-vip-c'
      if (c === '新出库') return 'tag-newout'
      return ''
    },
    isImageUrl(url) {
      if (!url) return false
      return /\.(png|jpe?g|gif|bmp|webp)(\?|$)/i.test(url)
    },
    fullUrl(url) {
      if (!url) return ''
      if (/^(https?:|data:)/i.test(url)) return url
      return this.apiOrigin + url
    },
    openAgreement(url) {
      if (!url) return
      window.open(this.fullUrl(url), '_blank')
    },
    beforeAgreementUpload(file) {
      const ok = file.size / 1024 / 1024 <= 20
      if (!ok) this.$message.error('文件不能超过 20MB')
      return ok
    },
    onAgreementSuccess(res) {
      if (res && res.success && res.url) {
        const list = this.agreementList(this.form)
        list.push(res.url)
        this.$set(this.form, 'agreementUrl', list.join(','))
        this.$message.success('上传成功')
      } else {
        this.$message.error((res && res.message) || '上传失败')
      }
    },
    onAgreementScanned(url) {
      // 高拍仪/摄像头扫描的进"附件"(signFile)，与协议附件(agreementUrl)分开
      const list = this.signList(this.form)
      list.push(url)
      this.$set(this.form, 'signFile', list.join(','))
    },
    onAgreementError() {
      this.$message.error('上传失败')
    },
    openAgrLog(row) {
      this.agrLogId = row.id
      this.agrLogVisible = true
    },
    agreementList(row) {
      if (!row || !row.agreementUrl) return []
      return String(row.agreementUrl).split(',').map(s => s.trim()).filter(Boolean)
    },
    removeAgreement(idx) {
      const list = this.agreementList(this.form)
      list.splice(idx, 1)
      this.$set(this.form, 'agreementUrl', list.join(','))
    },
    signList(row) {
      if (!row || !row.signFile) return []
      return String(row.signFile).split(',').map(s => s.trim()).filter(Boolean)
    },
    removeSign(idx) {
      const list = this.signList(this.form)
      list.splice(idx, 1)
      this.$set(this.form, 'signFile', list.join(','))
    },
    handleDelete(orderId) {
      this.$confirm(
        '<div style="line-height:1.8;font-size:14px">您正在<strong style="color:#F56C6C">永久删除</strong>这张销售订单！<br/>' +
        '删除后<strong style="color:#F56C6C">订单及其全部明细一并移除、无法恢复</strong>，该卡相关的剩余额度 / 剩余可领取也会随之变化。<br/>' +
        '请务必确认无误后再继续。</div>',
        '⚠ 危险操作 · 删除订单',
        {
          dangerouslyUseHTMLString: true,
          type: 'error',
          confirmButtonText: '确认永久删除',
          cancelButtonText: '我再想想',
          confirmButtonClass: 'el-button--danger',
          closeOnClickModal: false
        }
      ).then(() => {
        axios.delete('/order/' + orderId).then(res => {
          if (res.data) {
            this.$message.success('删除成功')
            this.loadList()
          }
        })
      }).catch(() => {})
    },
    exportCsv() {
      const cols = ['订单ID', '订单编号', '客户姓名', '产品名称', '规格', '单价', '数量', '赠送数量', '补贴', '实付', '欠款', '存货数量', '销售日期', '状态', '备注']
      const rows = []
      this.orderList.forEach(o => {
        const details = o.details || []
        const baseStatus = o.status === 3 ? '完结' : '未完结'
        if (details.length === 0) {
          rows.push([o.id, o.orderNo, o.customerName, '', '', '', '', '', '', '', '', '', this.formatDate(o.createTime), baseStatus, o.remark])
        } else {
          details.forEach(d => rows.push([
            o.id, o.orderNo, o.customerName, d.productName, d.spec,
            d.price, d.quantity, d.giftQuantity, d.subsidyAmount, d.actualAmount,
            d.debt, d.stockQuantity,
            this.formatDate(o.createTime), baseStatus, o.remark
          ]))
        }
      })
      const escaped = rows.map(r => r.map(v => v == null ? '' : String(v).replace(/,/g, '，')))
      const csv = '\uFEFF' + [cols.join(','), ...escaped.map(r => r.join(','))].join('\n')
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = '销售订单_' + new Date().toISOString().slice(0, 10) + '.csv'
      link.click()
    },
    formatDate(v) { return v ? String(v).replace('T', ' ').slice(0, 10) : '-' },
    // 列表内直接编辑订单欠款（仅超级管理员可操作）
    async editDebtInline(row) {
      const me = (function () { try { return JSON.parse(sessionStorage.getItem('user') || '{}') } catch (e) { return {} } })()
      const isSuper = me && (me.role === 'super_admin' || me.role === '超级管理员' || Number(me.roleId) === 1)
      if (!isSuper) {
        this.$message.warning('仅超级管理员可以修改欠款，请联系超级管理员操作')
        return
      }

      // 初始化弹窗数据
      this.debtDialog = {
        visible: true,
        row,
        debt: Number(row.debt || 0),
        payment: 0,
        paymentDate: new Date().toISOString().slice(0, 10),
        plans: [],
        nextExpectedDate: null,
        nextExpectedAmount: null
      }
      this.paymentAllocation = []

      // 获取未完成的还款计划
      try {
        const res = await axios.get(`/order/payment-plan/unpaid/${row.id}`)
        if (res.data && res.data.success) {
          this.debtDialog.plans = res.data.data || []
        }
      } catch (e) {
        console.error('获取还款计划失败:', e)
      }
    },
    submitDebt() {
      const dd = this.debtDialog
      const pay = Number(dd.payment || 0)

      // 校验
      if (!pay || pay <= 0) {
        this.$message.warning('请输入回款金额')
        return
      }
      if (!dd.paymentDate) {
        this.$message.warning('请选择回款日期')
        return
      }
      if (pay > Number(dd.debt || 0)) {
        this.$message.warning('回款金额不能大于当前欠款')
        return
      }

      // 构建请求数据
      const requestData = {
        orderId: dd.row.id,
        paymentAmount: pay,
        paymentDate: dd.paymentDate
      }

      // 调用登记回款接口
      axios.post('/order/recordPayment', requestData).then(res => {
        if (res.data && res.data.success) {
          const remaining = res.data.remainingDebt || 0
          if (remaining === 0) {
            this.$message.success('回款已登记，订单已结清 🎉')
          } else {
            this.$message.success(`回款已登记，剩余欠款 ¥${Number(remaining).toFixed(2)}`)
          }
          this.debtDialog.visible = false
          this.loadList()
          if (dd.row && dd.row.id) {
            this.loadChangeLog(dd.row.id)
            this.loadPaymentPlans(dd.row.id)
          }
        } else {
          this.$message.error(res.data.message || '登记失败')
        }
      }).catch(err => {
        console.error('登记回款失败:', err)
        this.$message.error('登记失败')
      })
    },
    // 预览本次回款会如何分配到各期（信用卡还款算法）
    previewPaymentAllocation() {
      this.paymentAllocation = []

      const pay = Number(this.debtDialog.payment || 0)
      if (!pay || pay <= 0) {
        return
      }

      let remaining = pay
      const plans = this.debtDialog.plans || []

      // 按期数顺序分配
      for (const plan of plans) {
        if (remaining <= 0) break

        // 该期还欠多少
        const debt = plan.expectedAmount - plan.paidAmount
        if (debt <= 0) continue

        // 本期可以还多少
        const toPay = Math.min(remaining, debt)

        // 本期还款后的总已还
        const newPaid = plan.paidAmount + toPay

        // 是否还完
        const complete = newPaid >= plan.expectedAmount

        this.paymentAllocation.push({
          period: plan.period,
          amount: toPay,
          complete: complete,
          remaining: complete ? 0 : plan.expectedAmount - newPaid
        })

        remaining -= toPay
      }
    },
    // 计算日期差（天数）
    daysDiff(date1, date2) {
      const d1 = new Date(date1)
      const d2 = new Date(date2)
      return Math.floor((d1 - d2) / (1000 * 60 * 60 * 24))
    },
    // 新增还款计划
    addPaymentPlan() {
      const current = Array.isArray(this.form.paymentPlans) ? this.form.paymentPlans : []
      const updated = [...current, {
        expectedDate: '',
        expectedAmount: 0
      }]
      this.$set(this.form, 'paymentPlans', updated)
      this.$forceUpdate()
    },
    // 删除还款计划
    removePaymentPlan(idx) {
      if (Array.isArray(this.form.paymentPlans)) {
        const updated = [...this.form.paymentPlans]
        updated.splice(idx, 1)
        this.$set(this.form, 'paymentPlans', updated)
        this.$forceUpdate()
      }
    },
    /** 列表"总金额" = 各明细 actualAmount 累加（已作废/已变更明细 voided===1 不计入），与弹窗 dialogTotalAmount 同口径 */
    rowTotal(o) {
      return ((o.details || [])
        .filter(d => Number(d.voided) !== 1)
        .reduce((s, d) => s + (Number(d.actualAmount) || 0), 0)).toFixed(2)
    },
    /** 数量汇总：各明细 quantity 累加（已作废/已变更明细 voided===1 不计入） */
    rowQty(o) {
      const n = (o.details || [])
        .filter(d => Number(d.voided) !== 1)
        .reduce((s, d) => s + (Number(d.quantity) || 0), 0)
      return n || '-'
    },
    /** 列表"总欠款" = 各明细 debt 累加 */
    rowDebt(o) {
      return ((o.details || []).reduce((s, d) => s + (Number(d.debt) || 0), 0)).toFixed(2)
    },
    fetchOrderAppsForLimit(orderId) {
      if (!orderId) return
      axios.get('/outbound/page', { params: { orderId: orderId, size: 100 } }).then(res => {
        const records = (res.data && res.data.records) || (Array.isArray(res.data) ? res.data : [])
        this.$set(this.orderAppsForLimitMap, orderId, records)
      }).catch(() => {})
    },
    getLatestAppTimeForOrder(orderId) {
      const apps = this.orderAppsForLimitMap[orderId] || []
      const dates = this.getServiceYearWindowDates()
      const winStartStr = dates ? this.fmtYMD(dates.winStart) + ' 00:00:00' : ''
      const winEndStr = dates ? this.fmtYMD(dates.winEnd) + ' 23:59:59' : ''
      let maxTimeStr = ''
      for (const a of apps) {
        if (!a) continue
        // 包含所有真实提货单据（待审核0、待出库1、已出库/已完结3、新出库4）；仅排除被驳回(-1/2)及已撤销作废(5/6)
        const st = Number(a.status)
        if (st === -1 || st === 2 || st === 5 || st === 6) continue
        const tStr = String(a.applicationTime || a.createTime || a.outboundDate || '').replace('T', ' ').slice(0, 19)
        if (winStartStr && tStr < winStartStr) continue
        if (winEndStr && tStr > winEndStr) continue
        if (tStr && tStr > maxTimeStr) maxTimeStr = tStr
      }
      return maxTimeStr ? maxTimeStr.slice(0, 16) : ''
    },
    getLatestAppTimeForProduct(orderId, productId) {
      if (!productId) return this.getLatestAppTimeForOrder(orderId)
      const apps = this.orderAppsForLimitMap[orderId] || []
      const dates = this.getServiceYearWindowDates()
      const winStartStr = dates ? this.fmtYMD(dates.winStart) + ' 00:00:00' : ''
      const winEndStr = dates ? this.fmtYMD(dates.winEnd) + ' 23:59:59' : ''
      let maxTimeStr = ''
      for (const a of apps) {
        if (!a) continue
        const st = Number(a.status)
        if (st === -1 || st === 2 || st === 5 || st === 6) continue
        const details = a.details || []
        const hasProd = details.length === 0 || details.some(d => d.productId === productId)
        if (hasProd) {
          const tStr = String(a.applicationTime || a.createTime || a.outboundDate || '').replace('T', ' ').slice(0, 19)
          if (winStartStr && tStr < winStartStr) continue
          if (winEndStr && tStr > winEndStr) continue
          if (tStr && tStr > maxTimeStr) maxTimeStr = tStr
        }
      }
      return maxTimeStr ? maxTimeStr.slice(0, 16) : ''
    },
    actualTimePickerOptionsForOrder(orderId) {
      const self = this
      return {
        disabledDate(time) {
          const dates = self.getServiceYearWindowDates()
          if (dates) {
            if (time.getTime() < dates.winStart.getTime() || time.getTime() > dates.winEnd.getTime()) {
              return true
            }
          }
          const maxStr = self.getLatestAppTimeForOrder(orderId)
          if (!maxStr) return false
          const isoStr = maxStr.replace(' ', 'T')
          const minDate = new Date(isoStr)
          if (isNaN(minDate.getTime())) return false
          minDate.setHours(0, 0, 0, 0)
          return time.getTime() < minDate.getTime()
        }
      }
    },
    actualTimePickerOptionsForProduct(orderId, productId) {
      const self = this
      return {
        disabledDate(time) {
          const dates = self.getServiceYearWindowDates()
          if (dates) {
            if (time.getTime() < dates.winStart.getTime() || time.getTime() > dates.winEnd.getTime()) {
              return true
            }
          }
          const maxStr = self.getLatestAppTimeForProduct(orderId, productId)
          if (!maxStr) return false
          const isoStr = maxStr.replace(' ', 'T')
          const minDate = new Date(isoStr)
          if (isNaN(minDate.getTime())) return false
          minDate.setHours(0, 0, 0, 0)
          return time.getTime() < minDate.getTime()
        }
      }
    },
    onActualUpdateTimeChange(val, orderId, productDetail) {
      if (!val) return
      let origVal = ''
      if (productDetail) {
        const idx = (this.form.details || []).indexOf(productDetail)
        if (idx >= 0 && this.originDetailActualUpdateTimeList) {
          origVal = this.originDetailActualUpdateTimeList[idx] || ''
        }
      } else {
        origVal = this.originActualUpdateTime || ''
      }
      const curVal = String(val).replace('T', ' ').slice(0, 16)
      if (origVal && curVal === origVal) return
      const dates = this.getServiceYearWindowDates()
      if (dates) {
        const selT = new Date(String(val).replace(' ', 'T')).getTime()
        if (!isNaN(selT) && (selT < dates.winStart.getTime() || selT > dates.winEnd.getTime())) {
          const startFmt = this.fmtYMD(dates.winStart)
          const endFmt = this.fmtYMD(dates.winEnd)
          this.$message.warning(`实际剩余时间必须在当前服务年度范围内（${startFmt} 至 ${endFmt}）！已重置。`)
          if (productDetail) {
            productDetail.actualUpdateTime = ''
          } else {
            this.form.actualUpdateTime = ''
          }
          return
        }
      }
      const maxStr = productDetail ? this.getLatestAppTimeForProduct(orderId, productDetail.productId) : this.getLatestAppTimeForOrder(orderId)
      if (maxStr && curVal <= maxStr) {
        this.$message.warning(`实际剩余时间不可早于或等于本年度最新提货时间（${maxStr}），避免重复扣减！已重置。`)
        if (productDetail) {
          productDetail.actualUpdateTime = ''
        } else {
          this.form.actualUpdateTime = ''
        }
      }
    }
  }
}
</script>

<style scoped>
.mb-4 { margin-bottom: 16px; }
.mt-4 { margin-top: 16px; }
.attach-log-imgs { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 4px; }
.attach-log-thumb { width: 80px; height: 80px; border-radius: 4px; border: 1px solid #e4e7ed; }
/* 变更记录排序依据提示 */
.change-log-hint { margin-top: 16px; padding: 6px 10px; background: #f4f4f5; border-radius: 4px; color: #909399; font-size: 12px; }
.change-log-hint i { color: #909399; margin-right: 4px; }
/* 手填的回款时间 / 修改·变更时间：统一蓝色 */
.biz-time { color: #409EFF; font-weight: 600; }
/* 变更记录 timeline：内容紧贴圆点（圆点位置保持 element ui 默认） */
.change-log-row >>> .el-timeline-item__wrapper { padding-left: 14px !important; }
/* 顶部操作时间：灰色（操作人黑色、业务时间蓝色，层次区分） */
.change-log-row >>> .el-timeline-item__timestamp { padding-top: 0; margin-bottom: 2px; color: #909399; font-size: 12px; }
.detail-log-pre {
  background: #fafbfc; border: 1px solid #ebeef5; border-radius: 4px;
  padding: 10px 12px; margin: 4px 0 0; font-size: 13px; line-height: 1.9;
  white-space: pre-wrap; word-break: break-all; color: #303133;
  font-family: -apple-system, "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif;
}
/* 明细 diff 卡片样式 */
.detail-diff-wrap { display: flex; flex-direction: row; gap: 12px; margin-top: 8px; }
.detail-diff-section { flex: 1; min-width: 0; background: #fafbfc; border: 1px solid #ebeef5; border-radius: 6px; padding: 10px 12px; }
.detail-diff-label { font-size: 12px; font-weight: 600; margin-bottom: 6px; }
.detail-diff-label.old { color: #909399; }
.detail-diff-label.new { color: #67C23A; }
.detail-diff-cards { display: flex; flex-direction: column; gap: 0; }
.detail-diff-card {
  background: transparent; border: none; border-radius: 0; padding: 8px 4px;
  display: flex; align-items: baseline; gap: 28px;
}
.detail-diff-card .ddc-title { margin-bottom: 0; flex-shrink: 0; }
.detail-diff-card .ddc-fields { flex: 1; }
.detail-diff-card + .detail-diff-card { border-top: 1px dashed #dcdfe6; }
/* 卡片整体着色：新增=绿、删除=红（不影响分隔线逻辑） */
.detail-diff-card.card-added { background: #f0f9eb; }
.detail-diff-card.card-deleted { background: #fef0f0; text-decoration: line-through; text-decoration-color: #F56C6C; text-decoration-thickness: 2px; color: #F56C6C; }
.detail-diff-card.card-deleted .ddc-title,
.detail-diff-card.card-deleted .ddc-field,
.detail-diff-card.card-deleted .ddc-k,
.detail-diff-card.card-deleted .ddc-v { color: #F56C6C; }
/* 已作废明细：醒目高亮（浅红底 + 左红边 + 标题红 + "已作废"角标）；与"删除"的整卡划线区分 */
.detail-diff-card.card-voided { background: #fef0f0; border-left: 3px solid #F56C6C; padding-left: 8px; border-radius: 4px; }
.detail-diff-card.card-voided .ddc-title { color: #F56C6C; font-weight: 700; }
.detail-diff-card.card-voided .ddc-title::after {
  content: "已作废"; margin-left: 8px; padding: 1px 6px; font-size: 11px; font-weight: 600;
  color: #fff; background: #F56C6C; border-radius: 3px; vertical-align: middle;
}
/* 整卡只在删除/新增时着色；只改字段时卡片保持默认，仅字段标橙 */
.ddc-title { font-size: 13px; font-weight: 600; color: #303133; margin-bottom: 4px; }
.ddc-fields { display: flex; flex-wrap: wrap; gap: 8px 32px; font-size: 12.5px; }
.ddc-field { color: #606266; }
/* 字段级：新明细里改动的字段标橙，旧明细里被改的字段标淡橙划线 */
.ddc-field.changed { color: #E6A23C; font-weight: 600; }
.ddc-field.old-changed { color: #E6A23C; text-decoration: line-through; opacity: 0.85; }
.ddc-k { color: #909399; margin-right: 4px; }
.ddc-field.changed .ddc-k, .ddc-field.old-changed .ddc-k { color: #E6A23C; }
.ddc-v { color: inherit; }
.hint { color: #909399; font-size: 12px; margin: 8px 0 0; }
.divider-text { color: #303133; font-size: 14px; font-weight: 600; }
.detail-card {
  background: #f8f9fb;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  padding: 14px 18px 4px;
  margin-bottom: 14px;
  position: relative;
  overflow: hidden;
}
/* 已作废：卡片整体淡灰，盖一个红色"已作废"印章 */
.detail-card--voided { background: #f5f5f5; }
.detail-card--voided .detail-card-body { opacity: .55; }
.void-stamp {
  position: absolute;
  top: 50%;
  right: 28px;
  transform: translateY(-50%) rotate(-18deg);
  color: #e74c3c;
  border: 3px solid #e74c3c;
  border-radius: 8px;
  padding: 4px 14px;
  font-size: 26px;
  font-weight: 900;
  letter-spacing: 6px;
  text-indent: 6px;
  opacity: .78;
  background: rgba(255, 255, 255, .35);
  box-shadow: 0 0 0 2px rgba(231, 76, 60, .25) inset;
  pointer-events: none;
  user-select: none;
  z-index: 3;
}
.detail-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #dcdfe6;
}
.detail-index { color: #409eff; font-weight: 600; font-size: 13px; }
.detail-remove { color: #f56c6c; }
/* 输入框 + 单位 后缀：el-input-number 无 append 插槽，用 flex 排版 */
.unit-wrap { display: flex; align-items: center; gap: 6px; }
.unit-wrap .el-input-number { flex: 1; }
.unit-suffix { color: #909399; font-size: 12px; flex-shrink: 0; }
/* 嵌入模式下分页左侧显示该客户销售订单的总计 */
.customer-totals { display: inline-block; margin-right: 0; padding-right: 4px; color: #303133; font-size: 17px !important; font-weight: 600; vertical-align: middle; }
.customer-totals span { font-size: 17px !important; }
.customer-totals b { color: #409eff; font-weight: 700; font-size: 19px !important; }
.customer-totals-warn { color: #f56c6c !important; }
.detail-taken-hint { margin-left: 12px; color: #909399; font-size: 12px; }
/* 是否变更：标签 + 开关，做成醒目药丸 */
.detail-change-toggle {
  display: inline-flex;
  align-items: center;
  margin-left: 12px;
  padding: 3px 12px;
  background: #fff7e6;
  border: 1px solid #ffd591;
  border-radius: 16px;
}
.dc-toggle-label {
  font-size: 14px;
  font-weight: 700;
  color: #d46b08;
  margin-right: 6px;
  line-height: 1;
  letter-spacing: 1px;
}
/* 开关上的"变更/不变更"文字加粗一点（scoped 下穿透 element-ui） */
.detail-change-toggle >>> .el-switch__label { font-weight: 700; }
/* 只让右侧"变更"激活时标红；左侧"不变更"用默认灰，不染红 */
.detail-change-toggle >>> .el-switch__label--right.is-active { color: #e74c3c; }
.detail-change-toggle >>> .el-switch__label--left.is-active { color: #909399; }
.dialog-footer-row { display: flex; align-items: center; justify-content: flex-end; gap: 10px; }
.footer-modify-date { display: inline-flex; align-items: center; margin-right: auto; }
.detail-wrap { padding: 0 30px; background: #fafbfc; }

/* 产品明细面板 */
.detail-panel {
  padding: 14px 24px 18px;
  background: linear-gradient(180deg, #fafcff 0%, #f5f7fa 100%);
  border-top: 1px dashed #dcdfe6;
}
.detail-panel-title {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #303133;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 12px;
}
.detail-panel-title i { color: #409eff; }
.detail-empty { color: #b8bccb; padding: 16px 0; text-align: center; }
.detail-grid { display: flex; flex-direction: column; gap: 10px; }
.detail-card-row {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.02);
  padding: 12px 14px;
}
/* 展开里已作废：整行淡红底、内容淡化，产品名后盖红色"已作废"小印章 */
.detail-card-row--voided {
  background: #fef0f0;
  border-color: #fbc4c4;
}
.detail-card-row--voided .detail-card-body { opacity: .5; }
.row-void-stamp {
  display: inline-block;
  margin-left: 8px;
  color: #e74c3c;
  border: 2px solid #e74c3c;
  border-radius: 4px;
  padding: 0 6px;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 2px;
  text-indent: 2px;
  line-height: 18px;
  transform: rotate(-8deg);
  background: rgba(231, 76, 60, .06);
}
.dbl-edit { cursor: pointer; transition: background .15s; }
.dbl-edit:hover { background: #f0f7ff; }
.detail-card-head {
  display: flex;
  align-items: center;
  gap: 14px;
  padding-bottom: 8px;
  margin-bottom: 8px;
  border-bottom: 1px dashed #ebeef5;
}
.dc-no {
  color: #fff;
  background: #409eff;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
}
.dc-name { color: #303133; font-weight: 600; font-size: 14px; }
.dc-spec { color: #909399; font-size: 12px; }
.detail-card-body {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
/* 尊贵卡C 最底部一行：协议剩余 + 应该剩余 + 实际剩余 同一行三分 */
.dc-last-row-triple {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-top: 6px;
  padding-top: 8px;
  border-top: 1px dashed #e4e7ed;
}
.dc-last-row-triple .dc-cell {
  flex: 1;
  margin: 0;
}
/* 基础信息那块仍用 4 列 grid */
.detail-card-body.cols-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}
/* 尊贵卡A/C：领取上限/已领取/在途/剩余可领取 这 4 个独占一行 */
.dc-cell-group {
  flex: 0 0 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.dc-cell.w4 { flex: 0 0 100%; grid-column: span 4; }
.dc-cell {
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  gap: 8px;
  padding: 4px 24px 4px 8px;
  background: #f8f9fb;
  border-radius: 4px;
  min-width: 300px;
  white-space: nowrap;
}
/* 送存货：cell 最小宽度收窄到 280 */
.detail-card-body.send-stock-cells .dc-cell { min-width: 280px; }
.dc-label { color: #909399; font-size: 12px; flex-shrink: 0; }
.dc-label::after { content: '：'; }
.dc-value { color: #303133; font-size: 13px; font-weight: 500; }
.dc-value.strong { color: #67c23a; font-weight: 600; }
.dc-value.warn { color: #f56c6c; font-weight: 600; }
.warn { color: #f56c6c; font-weight: 600; }
.muted { color: #909399; }
.agreement-preview { display: flex; flex-wrap: wrap; align-items: center; gap: 12px; margin-top: 8px; }
.agreement-preview .agreement-item { display: flex; align-items: center; }
.dc-cell.highlight { background: #fff7e6; border: 1px solid #ffd591; }
.dc-cell.highlight .dc-label { color: #d46b08; font-weight: 600; }
.dc-value.highlight-value { color: #d46b08; font-weight: 700; font-size: 14px; }
.vip-quota { margin-left: 14px; padding: 2px 10px; background: #fff7e6; color: #d46b08; border-radius: 10px; font-size: 12px; font-weight: 600; }
/* 尊贵卡C 紫色调，区别于 A(绿)/B(蓝)/info 灰；scoped 下用 ::v-deep 穿透 element-ui */
::v-deep .el-tag.tag-vip-c {
  background-color: #f4ecfb !important;
  border-color: #d3b4f1 !important;
  color: #722ed1 !important;
}
::v-deep .el-tag.tag-vip-a {
  background-color: #fff1b8 !important;
  border-color: #faad14 !important;
  color: #874d00 !important;
  font-weight: 600 !important;
}
::v-deep .el-tag.tag-vip-b {
  background-color: #fff0f6 !important;
  border-color: #ff85c0 !important;
  color: #c41d7f !important;
}
::v-deep .el-tag.tag-newout {
  background-color: #e6fffb !important;
  border-color: #5cdbd3 !important;
  color: #08979c !important;
}
/* 休眠状态：高对比深红填充 + 加粗 + 阴影 + 缓慢脉动；醒目用 */
::v-deep .el-tag.dormant-flag {
  font-weight: 700 !important;
  letter-spacing: 1px;
  box-shadow: 0 0 0 2px rgba(245, 108, 108, .25);
  animation: dormantPulse 1.6s ease-in-out infinite;
}
@keyframes dormantPulse {
  0%, 100% { box-shadow: 0 0 0 2px rgba(245, 108, 108, .15); }
  50%      { box-shadow: 0 0 0 4px rgba(245, 108, 108, .45); }
}
/* 展开行附件缩略图 / 文件链接 */
.file-thumbs { display: inline-flex; flex-wrap: wrap; gap: 6px; align-items: center; }
.file-thumb-sm { width: 40px; height: 40px; border-radius: 4px; }
.file-link-sm { font-size: 12px; color: #409eff; text-decoration: none; padding: 2px 8px; background: #ecf5ff; border-radius: 3px; max-width: 220px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
</style>

<style>
.sales-order-date-popper {
  z-index: 99999 !important;
}
</style>
